<template>
  <PublicTemplate :transparent="1">
    <section class="Hero__HeroWrap-sc-7askzs-0 hliIzh">
      <swiper :spaceBetween="30" :centeredSlides="true" :autoplay="{
        delay: 5000,
        disableOnInteraction: false,
      }" :pagination="{
        clickable: true,
      }" :navigation="true" :loop="true" :modules="modules" @autoplayTimeLeft="onAutoplayTimeLeft" class="mySwiper">
        <swiper-slide>

          <img src="/uploads/1_b0e151a07e.jpg" alt="test" loading="lazy">
          <div class="content">
            <h1>
              Nghệ thuật phụ kiện chính hiệu | Dòng tay nắm Venice</h1>
            <router-link to="/product/handle-series">
              Khám phá thêm</router-link>
          </div>
        </swiper-slide>
        <swiper-slide>
          <img src="/uploads/banner_172b47b297.jpg" alt="test" loading="lazy">
          <div class="content">
            <h1>
              Dòng tay nắm Milan vừa vặn</h1>
            <router-link to="/product/handle-series/milan">
              Khám phá thêm</router-link>
          </div>
        </swiper-slide>
        <swiper-slide>
          <img src="/uploads/banner_ddd8e3982d.png" alt="test" loading="lazy">
          <div class="content">
            <h1>
              Tay nắm cửa và cửa sổ</h1>
            <router-link to="/product/handle-series/metro">
              Khám phá thêm</router-link>
          </div>
        </swiper-slide>
        <swiper-slide>
          <img src="/uploads/1_1a1acedfec.png" alt="test" loading="lazy">
          <div class="content">
            <h1>
              Đổi mới trong từng chi tiết | CMECH</h1>
            <router-link to="/product/window/out-swing-casement">
              Khám phá thêm</router-link>
          </div>
        </swiper-slide>
        <swiper-slide>
          <img src="/uploads/2_1ba1d5289e.png" alt="test" loading="lazy">
          <div class="content">
            <h1>
              Hệ thống phụ kiện cửa sổ mở trong lật</h1>
            <router-link to="/product/window/tilt-and-turn-inswing">
              Khám phá thêm</router-link>
          </div>
        </swiper-slide>

        <template #container-end>
          <div class="autoplay-progress">
            <svg viewBox="0 0 48 48" ref="progressCircle">
              <circle cx="24" cy="24" r="20"></circle>
            </svg>
            <span ref="progressContent"></span>
          </div>
        </template>
      </swiper>
    </section>
    <section class="Collections__CollectionsSection-sc-10sxv7l-0 hYNhoE section_paddings ">
      <div class="animated fadeInUp" style="animation-duration: 1s;">
        <div class="container">
          <h2 class="section_subtitle">
            Khám phá sản phẩm CMECH</h2>
          <h3 class="section_title">
            Đổi mới chi tiết<!-- -->
          </h3>
          <p class="content_center section_description">
            CMECH không chỉ sử dụng vật liệu sáng bóng trong thiết kế sản phẩm, mà còn tỏa sáng ở mọi bước trong quy
            trình sản xuất và dịch vụ. Từ thiết kế đạt giải thưởng đến nhóm kiểm tra tuổi thọ và kiểm soát chất
            lượng tốt nhất, CMECH mang lại vô vàn lợi ích.</p>
          <ul>
            <li>
              <router-link to="/product/window/out-swing-casement">
                <svg width="59" height="65" viewBox="0 0 59 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M56.8075 64.7249H11.7932C10.6633 64.7249 9.74722 63.7663 9.74722 62.5839V34.7487C9.74722 34.1579 10.205 33.6784 10.77 33.6784C11.335 33.6784 11.7932 34.1579 11.7932 34.7487V62.5839H56.8075V2.6315H11.7932V14.7398C11.7932 15.3314 11.335 15.8105 10.77 15.8105C10.205 15.8105 9.74722 15.3314 9.74722 14.7398V2.6315C9.74722 1.44906 10.6633 0.490479 11.7932 0.490479H56.8075C57.9374 0.490479 58.8535 1.44906 58.8535 2.6315V62.5839C58.8535 63.7663 57.9374 64.7249 56.8075 64.7249ZM53.7383 60.4429H14.862C14.2974 60.4429 13.8392 59.9634 13.8392 59.3718V45.4546C13.8392 44.8634 14.2974 44.3843 14.862 44.3843H53.7383C54.3033 44.3843 54.7611 44.8634 54.7611 45.4546V59.3718C54.7611 59.9634 54.3033 60.4429 53.7383 60.4429ZM15.8852 58.3015H52.7151V46.5253H15.8852V58.3015ZM53.7383 42.2429H14.862C14.2974 42.2429 13.8392 41.7638 13.8392 41.1722V34.7487C13.8392 34.1579 14.2974 33.6784 14.862 33.6784C15.4273 33.6784 15.8852 34.1579 15.8852 34.7487V40.1018H52.7151V6.91392H14.862C14.2974 6.91392 13.8392 6.43444 13.8392 5.84361C13.8392 5.252 14.2974 4.77251 14.862 4.77251H53.7383C54.3033 4.77251 54.7611 5.252 54.7611 5.84361V41.1722C54.7611 41.7638 54.3033 42.2429 53.7383 42.2429Z"
                    fill="black">
                  </path>
                  <path
                    d="M53.7383 42.2429H14.862C14.2974 42.2429 13.8392 41.7638 13.8392 41.1722V34.7488C13.8392 34.158 14.2974 33.6785 14.862 33.6785C15.4274 33.6785 15.8852 34.158 15.8852 34.7488V40.1019H52.7152V6.91399H14.862C14.2974 6.91399 13.8392 6.43451 13.8392 5.84368C13.8392 5.25207 14.2974 4.77258 14.862 4.77258H53.7383C54.3033 4.77258 54.7612 5.25207 54.7612 5.84368V41.1722C54.7612 41.7638 54.3033 42.2429 53.7383 42.2429Z"
                    fill="black">
                  </path>
                  <path
                    d="M53.7383 60.4428H14.862C14.2974 60.4428 13.8392 59.9633 13.8392 59.3717V45.4545C13.8392 44.8632 14.2974 44.3842 14.862 44.3842H53.7383C54.3033 44.3842 54.7612 44.8632 54.7612 45.4545V59.3717C54.7612 59.9633 54.3033 60.4428 53.7383 60.4428ZM15.8852 58.3014H52.7152V46.5252H15.8852V58.3014Z"
                    fill="black">
                  </path>
                  <path
                    d="M53.7383 42.2429H14.862C14.2974 42.2429 13.8392 41.7638 13.8392 41.1722V34.7488C13.8392 34.158 14.2974 33.6785 14.862 33.6785C15.4274 33.6785 15.8852 34.158 15.8852 34.7488V40.1019H52.7152V6.91399H14.862C14.2974 6.91399 13.8392 6.43451 13.8392 5.84368C13.8392 5.25207 14.2974 4.77258 14.862 4.77258H53.7383C54.3033 4.77258 54.7612 5.25207 54.7612 5.84368V41.1722C54.7612 41.7638 54.3033 42.2429 53.7383 42.2429Z"
                    fill="black">
                  </path>
                  <path
                    d="M40.4388 35.8195H1.56286C1.21106 35.8191 0.883608 35.6297 0.696656 35.3177C0.510079 35.0064 0.489473 34.6159 0.641582 34.2842L13.9414 5.37909C14.1119 5.0086 14.4697 4.77337 14.8619 4.77258H53.7383C54.0901 4.77337 54.4171 4.96234 54.6037 5.27402C54.7907 5.58649 54.8117 5.97619 54.6592 6.30827L41.3593 35.2134C41.1889 35.5835 40.8311 35.8191 40.4388 35.8195V35.8195ZM3.18998 33.6785H39.7963L52.1104 6.91399H15.5045L3.18998 33.6785Z"
                    fill="black">
                  </path>
                  <path
                    d="M37.8669 31.537H8.07441C7.72261 31.537 7.39554 31.3472 7.20896 31.0356C7.02201 30.7239 7.00103 30.3334 7.15351 30.0021L16.5135 9.66105C16.684 9.29056 17.0418 9.05532 17.434 9.05493H47.2265C47.5783 9.05532 47.905 9.24469 48.0919 9.55676C48.2793 9.86845 48.2999 10.2585 48.1474 10.5902L38.7874 30.9313C38.6169 31.3014 38.2591 31.537 37.8669 31.537V31.537ZM9.70303 29.396H37.2232L45.5967 11.1959H18.0765L9.70303 29.396Z"
                    fill="black">
                  </path>
                  <path
                    d="M53.7383 60.4428H14.862C14.2974 60.4428 13.8392 59.9633 13.8392 59.3717V45.4545C13.8392 44.8632 14.2974 44.3842 14.862 44.3842H53.7383C54.3033 44.3842 54.7612 44.8632 54.7612 45.4545V59.3717C54.7612 59.9633 54.3033 60.4428 53.7383 60.4428ZM15.8852 58.3014H52.7152V46.5252H15.8852V58.3014Z"
                    fill="black">
                  </path>
                  <path
                    d="M53.7383 27.2546C53.4667 27.2546 53.207 27.1421 53.0149 26.9409L46.8765 20.5175C46.4888 20.0976 46.4944 19.4299 46.8893 19.0171C47.2838 18.6039 47.9218 18.598 48.3234 19.0038L54.4614 25.4272C54.7544 25.7334 54.8417 26.1941 54.6836 26.594C54.5251 26.9939 54.1519 27.2546 53.7383 27.2546V27.2546Z"
                    fill="black">
                  </path>
                  <path
                    d="M28.1618 42.2428C27.8906 42.2428 27.6305 42.1299 27.4387 41.9291L21.3004 35.5057C20.9126 35.0854 20.9182 34.4181 21.3128 34.0049C21.7073 33.5921 22.3457 33.5862 22.7469 33.992L28.8853 40.4154C29.1775 40.7216 29.2652 41.1819 29.1067 41.5818C28.9486 41.9817 28.5758 42.2428 28.1618 42.2428V42.2428Z"
                    fill="black">
                  </path>
                </svg>
                <h4>
                  Phụ kiện cửa sổ</h4>
                <p>
                  Phụ kiện cửa sổ của CMECH mang đến phong cách sống đẳng cấp.</p>
                <span>
                  Khám phá thêm</span>
              </router-link>
            </li>
            <li>
              <router-link to="/product/door/hinged">
                <svg width="43" height="65" viewBox="0 0 43 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M18.3137 33.7H14.4797C13.8603 33.7 13.3584 34.2021 13.3584 34.8213C13.3584 35.4406 13.8603 35.9427 14.4797 35.9427H18.3137C18.9332 35.9427 19.4351 35.4406 19.4351 34.8213C19.4351 34.2021 18.9331 33.7 18.3137 33.7Z"
                    fill="black">
                  </path>
                  <path
                    d="M41.1981 3.25574H24.6559V1.1214C24.6559 0.773046 24.4939 0.444365 24.2177 0.232227C23.9411 0.0199616 23.582 -0.0520207 23.2454 0.0379889L0.832431 6.0148C0.341504 6.14569 0 6.59028 0 7.09834V10.7204C0 11.3397 0.501971 11.8418 1.12137 11.8418C1.74078 11.8418 2.24275 11.3397 2.24275 10.7204V7.95997L22.413 2.58111V62.5106L2.24275 58.4765V14.5001C2.24275 13.8808 1.74078 13.3787 1.12137 13.3787C0.501971 13.3787 0 13.8808 0 14.5001V59.3959C0 59.9305 0.377178 60.3907 0.901493 60.4955L23.3145 64.9782C23.3875 64.9928 23.461 65 23.5344 65C23.7915 65 24.0431 64.9116 24.2453 64.7458C24.5051 64.5328 24.6558 64.2145 24.6558 63.8786V61.7446H34.9904C35.6099 61.7446 36.1117 61.2425 36.1117 60.6232C36.1117 60.0039 35.6098 59.5018 34.9904 59.5018H24.6558V56.3022H35.7554C36.3749 56.3022 36.8768 55.8001 36.8768 55.1808V9.81958C36.8768 9.2003 36.3748 8.6982 35.7554 8.6982H24.6558V5.49848H40.0765V59.5013H38.4766C37.8571 59.5013 37.3552 60.0034 37.3552 60.6227C37.3552 61.2419 37.8572 61.744 38.4766 61.744H41.1978C41.8174 61.744 42.3192 61.2419 42.3192 60.6227V4.37711C42.3195 3.75783 41.8174 3.25574 41.1981 3.25574ZM34.6341 10.941V54.0591H24.656V10.941H34.6341Z"
                    fill="black">
                  </path>
                </svg>
                <h4>
                  Phụ kiện cửa</h4>
                <p>
                  Phụ kiện cửa sáng tạo của chúng tôi đảm bảo vận hành trơn tru và an toàn tối ưu.</p>
                <span>
                  Khám phá thêm</span>
              </router-link>
            </li>
            <li>
              <router-link to="/product/handle-series/venice-series">
                <svg width="45" height="65" viewBox="0 0 45 65" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M44.0492 11.8615C43.5242 11.8615 43.0985 12.2872 43.0985 12.8122V63.0157H14.319V35.8324H20.3578C22.1516 38.5409 25.224 40.3321 28.7089 40.3321C34.2303 40.3321 38.7222 35.8401 38.7222 30.3188C38.7222 24.7974 34.2303 20.3054 28.7089 20.3054C25.2242 20.3054 22.1525 22.0967 20.3588 24.8051H14.319V1.90123H43.0986V5.88323C43.0986 6.40827 43.5242 6.8339 44.0493 6.8339C44.5744 6.8339 45 6.40827 45 5.88323V1.55496C44.9997 0.697604 44.3023 0 43.4449 0H13.9727C13.1154 0 12.4178 0.697604 12.4178 1.55496V24.8053H5.51363C2.47331 24.8053 0 27.2787 0 30.3189C0 32.8225 1.69418 35.016 4.11982 35.653C4.62762 35.7865 5.14746 35.4828 5.28072 34.975C5.41397 34.4672 5.11056 33.9475 4.60276 33.8141C3.01205 33.3963 1.9011 31.959 1.9011 30.3189C1.9011 28.327 3.52162 26.7066 5.5135 26.7066H26.8074C28.7993 26.7066 30.4198 28.3271 30.4198 30.319C30.4198 32.3109 28.7993 33.9314 26.8074 33.9314H11.0061C10.481 33.9314 10.0554 34.357 10.0554 34.8821C10.0554 35.4071 10.4809 35.8328 11.0061 35.8328H12.4178V63.3625C12.4178 64.2199 13.1153 64.9175 13.9727 64.9175H43.445C44.3024 64.9175 45 64.2199 45 63.3625V12.8122C44.9999 12.2872 44.5744 11.8615 44.0492 11.8615ZM26.8074 35.8324C29.8477 35.8324 32.321 33.3589 32.321 30.3186C32.321 27.2784 29.8477 24.805 26.8074 24.805H22.767C24.249 23.2082 26.3635 22.2067 28.7088 22.2067C33.1818 22.2067 36.8207 25.8457 36.8207 30.3186C36.8207 34.7916 33.1817 38.4307 28.7088 38.4307C26.3631 38.4307 24.2477 37.4293 22.7653 35.8324H26.8074V35.8324Z"
                    fill="black">
                  </path>
                  <path
                    d="M28.7088 44.739C26.6469 44.739 24.9693 46.4165 24.9693 48.4785C24.9693 49.5132 25.4012 50.4976 26.1449 51.1994V53.1996C26.1449 54.6134 27.295 55.7635 28.7088 55.7635C30.1225 55.7635 31.2726 54.6134 31.2726 53.1996V51.1994C32.0164 50.4977 32.4482 49.5132 32.4482 48.4785C32.4482 46.4166 30.7706 44.739 28.7088 44.739ZM29.7713 49.9778C29.5204 50.156 29.3714 50.4449 29.3714 50.7527V53.1996C29.3714 53.5588 29.068 53.8623 28.7088 53.8623C28.3496 53.8623 28.0461 53.5588 28.0461 53.1996V50.7527C28.0461 50.4449 27.8972 50.156 27.6463 49.9778C27.1605 49.6328 26.8705 49.0722 26.8705 48.4785C26.8705 47.4649 27.6951 46.6402 28.7088 46.6402C29.7225 46.6402 30.547 47.4649 30.547 48.4785C30.547 49.0721 30.257 49.6326 29.7713 49.9778Z"
                    fill="black">
                  </path>
                </svg>
                <h4>Tay nắm cửa</h4>
                <p>
                  Tay nắm hiện đại của CMECH được chế tạo từ kim loại chống ăn mòn và công nghệ xử lý bề mặt M đảm
                  bảo không phai màu trong nhiều năm.</p>
                <span>
                  Khám phá thêm</span>
              </router-link>
            </li>
            <li>
              <router-link to="/product/solutions/gliding-window-system">
                <svg xmlns="http://www.w3.org/2000/svg" width="70" height="682.667" version="1" viewBox="0 0 512 512">
                  <path
                    d="M580 3285V1710h1610V260h139c77 0 142 4 146 9 3 6 309 224 680 487l675 477v2435l-625 442c-344 243-625 444-625 446s378 4 840 4h840V260h280v4600H580V3285zm3870-725V340h-110v4310H2390V340h-110v1450H670v2990h3780V2560zM3126 4059l624-441V1284l-626-443c-344-243-632-445-640-448-12-4-14 275-14 2057 0 1887 1 2062 16 2056 9-3 297-205 640-447z"
                    transform="matrix(.1 0 0 -.1 0 512)">
                  </path>
                  <path d="M780 3290V1930h1500v2720H780V3290zm1410-5V2010l-662 2-663 3-3 1273-2 1272h1330V3285z"
                    transform="matrix(.1 0 0 -.1 0 512)">
                  </path>
                  <path
                    d="M1462 3607l-192-193 33-32 33-32 192 193 192 193-33 32-33 32-192-193zM1415 3260l-110-110 33-32 32-33 112 112 112 112-29 31c-16 16-31 30-35 30-3 0-55-49-115-110zM1497 3062l-228-228 31-29 31-29 227 227 227 227-30 30-30 30-228-228zM3390 2510v-100l28-5c66-14 62-17 62 36 0 56 2 56 78 34l52-16v-338l-37-10c-21-5-50-13-65-17l-28-6v224l-37-7c-21-4-41-9-45-11-9-6-11-298-2-306 3-3 69 15 147 41l142 48 3 220 2 221-137 46c-76 25-144 46-151 46-9 0-12-27-12-100z"
                    transform="matrix(.1 0 0 -.1 0 512)">
                  </path>
                  <path d="M3310 2359v-42l93 7c122 9 177 17 177 26 0 5-236 50-262 50-5 0-8-19-8-41z"
                    transform="matrix(.1 0 0 -.1 0 512)">
                  </path>
                </svg>
                <h4>
                  Hệ thống</h4>
                <p>
                  CMECH cung cấp các giải pháp hệ thống hiệu quả và tiện lợi, đáp ứng mọi nhu cầu của bạn.</p>
                <span>
                  Khám phá thêm</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <section class="Why__WhySection-q1jlkv-0 eHMvFR section_paddings ">
      <div class="container_small">
        <div class="animated fadeInUp" style="animation-duration: 1s;">
          <div class="heading">
            <h4 class="section_subtitle">
              Định nghĩa lại phụ kiện cửa và cửa sổ từ năm 1994</h4>
            <h2 class="section_title">
              CMECH</h2>
          </div>
          <div class="section_description content">
            <p class="content_wrap">
              Từ kiến trúc sư, nhà thiết kế đến nhà phát triển bất động sản, các lãnh đạo ngành xây dựng đều coi
              trọng việc thúc đẩy thiết kế sản phẩm chất lượng cao, phát triển công nghệ xây dựng thông minh sáng
              tạo và sử dụng vật liệu bền vững. Trong 30 năm qua, ngành đã tin tưởng CMECH với các giải pháp phụ
              kiện cửa và cửa sổ bền vững và hoàn chỉnh, bao gồm hệ thống khóa đa điểm an toàn, bản lề cửa sổ an
              toàn, bánh xe chịu lực bền bỉ, tay nắm tiện dụng và khả năng chống ăn mòn.</p>
          </div>
        </div>
        <div class="why_grid">
          <div class="animated fadeInUp" style="animation-duration: 1s;">
            <div class="video">
              <svg v-if="!isPlayVideo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 477.867 477.867">
                <path
                  d="M238.933 0C106.974 0 0 106.974 0 238.933s106.974 238.933 238.933 238.933 238.933-106.974 238.933-238.933C477.726 107.033 370.834.141 238.933 0zm100.624 246.546a17.068 17.068 0 01-7.662 7.662v.085L195.362 322.56c-8.432 4.213-18.682.794-22.896-7.638a17.061 17.061 0 01-1.8-7.722V170.667c-.004-9.426 7.633-17.07 17.059-17.075a17.068 17.068 0 017.637 1.8l136.533 68.267c8.436 4.204 11.867 14.451 7.662 22.887z">
                </path>
              </svg>
              <video v-on:click="playVideo" poster="/uploads/video_cover_0ad9948c8d.jpeg">
                <source src="/uploads/201909071426295736_1_8485b6836a.mp4" type="video/mp4">
              </video>
            </div>
          </div>
          <div class="animated fadeInUp" style="animation-duration: 1s;">
            <div class="gallery">
              <img src="/uploads/why_left_image_859989130d_7fc44c0fc5_1e3e0d6aac_36adeee568.jpg" alt="why us">
            </div>
          </div>
        </div>
      </div>
      <div class="animated fadeInUp" style="animation-duration: 1s;">
        <div class="why_button_wrapper">
          <div class="SiteButton__LinkWrapper-o4bfn9-0 iBTqZx link_wrapper">
            <router-link to="/about/company">
              Câu chuyện của chúng tôi</router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="TailoredForIndustry__TailoredTabs-sc-1g08m1a-0 ccBpZc">
      <div class="container">
        <div class="animated fadeInUp" style="animation-duration: 1s;">
          <h4 class="section_subtitle">
            Sứ mệnh CMECH</h4>
          <h2 class="section_title">
            Tùy chỉnh cho ngành của bạn</h2>
        </div>
        <div class="animated fadeInUp" style="animation-duration: 1s;">
          <div class="react-tabs" data-tabs="true">
            <ul class="react-tabs__tab-list" role="tablist">
              <div class="tabs_wrap">
                <li class="react-tabs__tab" v-on:click="tab = 1"
                  v-bind:class="{ 'react-tabs__tab--selected': tab == 1 }" role="tab" id="react-tabs-468180">
                  <div class="svg_wrapper">
                    <svg width="45" height="34" viewBox="0 0 45 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M44.25 9V33H3C2.37936 33 1.81686 32.7478 1.40907 32.3409C1.00218 31.9331 0.75 31.3706 0.75 30.75C0.75 29.5078 1.75781 28.5 3 28.5H5.25V9H44.25Z"
                        fill="#96BACC">
                      </path>
                      <path
                        d="M22.5 14.1213L27.75 19.3713V25.5H17.25V19.3713L22.5 14.1213ZM22.5 12L15.75 18.75V27H29.25V18.75L22.5 12Z"
                        fill="#35495E">
                      </path>
                      <path
                        d="M24.75 24.75H20.25C19.8358 24.75 19.5 24.4142 19.5 24V19.5C19.5 19.0858 19.8358 18.75 20.25 18.75H24.75C25.1642 18.75 25.5 19.0858 25.5 19.5V24C25.5 24.4142 25.1642 24.75 24.75 24.75ZM21 23.25H24V20.25H21V23.25Z"
                        fill="#35495E">
                      </path>
                      <path
                        d="M5.25 4.5V28.5H3C1.75781 28.5 0.75 29.5078 0.75 30.75V6.75C0.75 5.50781 1.75781 4.5 3 4.5H5.25Z"
                        fill="#C4D4DE">
                      </path>
                      <path
                        d="M42.75 10.5V31.5H3C2.73022 31.5 2.55121 31.3616 2.47094 31.2815C2.38843 31.1988 2.25 31.0198 2.25 30.75C2.25 30.3365 2.58646 30 3 30H5.25C6.07844 30 6.75 29.3284 6.75 28.5V10.5H42.75ZM44.25 9H5.25V28.5H3C1.75781 28.5 0.75 29.5078 0.75 30.75C0.75 31.3706 1.00218 31.9331 1.40907 32.3409C1.81686 32.7478 2.37936 33 3 33H44.25V9Z"
                        fill="#35495E">
                      </path>
                      <path d="M21 0.75H24V5.25H21V0.75Z" fill="#F98800">
                      </path>
                      <path d="M20.9958 9.00171L23.9953 6.00215L36.7434 18.7502L33.7439 21.7498L20.9958 9.00171Z"
                        fill="#EFEEEF">
                      </path>
                      <path d="M8.24701 18.749L20.9951 6.00096L23.9946 9.00051L11.2466 21.7486L8.24701 18.749Z"
                        fill="#EFEEEF">
                      </path>
                      <path d="M11.25 21.75L8.25 27V21L11.25 21.75Z" fill="#EFEEEF">
                      </path>
                      <path d="M38.25 15.75H41.25V24.75H38.25V15.75Z" fill="#FFEC00">
                      </path>
                      <path d="M38.25 24.75L39.75 27.75L41.25 24.75H38.25Z" fill="#F98800">
                      </path>
                      <path
                        d="M22.5 18.7212C20.1852 18.7212 17.9626 18.022 16.0725 16.6991C14.2258 15.4065 12.8244 13.6152 12.0201 11.5187C11.8717 11.1319 12.0649 10.6982 12.4516 10.5497C12.8385 10.4016 13.2722 10.5946 13.4205 10.9813C14.8525 14.7136 18.5013 17.2212 22.5 17.2212C26.4987 17.2212 30.1475 14.7136 31.5795 10.9813C31.7279 10.5946 32.162 10.4015 32.5484 10.5497C32.9351 10.6982 33.1283 11.1319 32.98 11.5187C32.1756 13.6152 30.7742 15.4065 28.9275 16.6991C27.0374 18.022 24.8148 18.7212 22.5 18.7212Z"
                        fill="#F98800">
                      </path>
                      <path
                        d="M35.2501 22.5C36.4927 22.5 37.5001 21.4926 37.5001 20.25C37.5001 19.0074 36.4927 18 35.2501 18C34.0074 18 33.0001 19.0074 33.0001 20.25C33.0001 21.4926 34.0074 22.5 35.2501 22.5Z"
                        fill="#F98800">
                      </path>
                      <path
                        d="M22.5 9.75C23.7426 9.75 24.75 8.74264 24.75 7.5C24.75 6.25736 23.7426 5.25 22.5 5.25C21.2574 5.25 20.25 6.25736 20.25 7.5C20.25 8.74264 21.2574 9.75 22.5 9.75Z"
                        fill="#F98800">
                      </path>
                      <path
                        d="M9.75 22.5C10.9926 22.5 12 21.4926 12 20.25C12 19.0074 10.9926 18 9.75 18C8.50736 18 7.5 19.0074 7.5 20.25C7.5 21.4926 8.50736 22.5 9.75 22.5Z"
                        fill="#F98800">
                      </path>
                      <path
                        d="M44.25 8.25H27.3106L25.1398 6.07919C25.0218 5.8604 24.8787 5.65928 24.7139 5.47956C24.7372 5.40717 24.75 5.33012 24.75 5.25V0.75C24.75 0.33577 24.4142 0 24 0H21C20.5858 0 20.25 0.33577 20.25 0.75V5.25C20.25 5.33004 20.2628 5.40702 20.286 5.47935C20.1211 5.65918 19.978 5.86042 19.8601 6.07929L17.6894 8.25H6V4.5C6 4.08577 5.66423 3.75 5.25 3.75H3C1.34578 3.75 0 5.09578 0 6.75V30.75C0 31.5499 0.311829 32.3031 0.879318 32.8719C1.4469 33.4382 2.20006 33.75 3 33.75H44.25C44.6642 33.75 45 33.4142 45 33V9C45 8.58577 44.6642 8.25 44.25 8.25ZM33.75 20.25C33.75 19.4229 34.4229 18.75 35.25 18.75C36.0771 18.75 36.75 19.4229 36.75 20.25C36.75 21.0771 36.0771 21.75 35.25 21.75C34.4229 21.75 33.75 21.0771 33.75 20.25ZM32.3938 19.3332L29.4046 16.344C30.1331 15.7754 30.7849 15.1262 31.3468 14.4074L34.3332 17.3938C33.4153 17.6892 32.6892 18.4153 32.3938 19.3332ZM28.3274 15.2668L23.5606 10.5L23.9208 10.1398C24.6086 9.7689 25.1181 9.14298 25.3537 8.41433L30.2715 13.3321C29.7154 14.0677 29.0596 14.7185 28.3274 15.2668ZM9 23.1541C9.17418 23.1991 9.35281 23.2285 9.5341 23.2415L9 24.1761V23.1541ZM11.1026 20.8976C10.9954 21.1227 10.8306 21.3195 10.6256 21.4671C10.369 21.6522 10.0663 21.75 9.75 21.75C9.38049 21.75 9.02559 21.6143 8.74988 21.3671C8.43219 21.0831 8.25 20.6759 8.25 20.25C8.25 19.676 8.58495 19.1449 9.10332 18.8969L9.10328 18.8968C9.10376 18.8966 9.10426 18.8964 9.10474 18.8962C9.30647 18.7992 9.52359 18.75 9.75 18.75C10.5771 18.75 11.25 19.4229 11.25 20.25C11.25 20.4764 11.2008 20.6935 11.1038 20.8953C11.1034 20.8961 11.1031 20.8969 11.1028 20.8977L11.1026 20.8976ZM10.6673 17.3934L13.6532 14.4074C14.2151 15.1262 14.8669 15.7754 15.5954 16.344L12.6066 19.3327C12.3112 18.415 11.585 17.6888 10.6673 17.3934ZM14.7285 13.3321L19.6463 8.41434C19.8962 9.1874 20.4534 9.84623 21.2046 10.2056C21.3282 10.265 21.4548 10.3144 21.5835 10.3559L16.6726 15.2668C15.9404 14.7185 15.2846 14.0677 14.7285 13.3321ZM23.8538 6.85474C23.9508 7.05647 24 7.27354 24 7.5C24 8.07404 23.6651 8.60513 23.1453 8.85379C22.9435 8.95079 22.7265 9 22.5 9C22.2735 9 22.0565 8.95079 21.8533 8.8531C21.3349 8.60513 21 8.07404 21 7.5C21 7.27354 21.0492 7.05647 21.1469 6.85332C21.3949 6.33495 21.926 6 22.5 6C23.074 6 23.6051 6.33495 23.8538 6.85474ZM22.5 11.5606L27.0287 16.0894C25.6562 16.8157 24.1065 17.2212 22.5 17.2212C20.8934 17.2212 19.3438 16.8157 17.9713 16.0894L22.5 11.5606ZM21.75 1.5H23.25V4.5H21.75V1.5ZM3 5.25H4.5V27.75H3C2.45376 27.75 1.94163 27.8975 1.5 28.1536V6.75C1.5 5.92291 2.17291 5.25 3 5.25ZM43.5 32.25H3C2.60005 32.25 2.22318 32.0937 1.94 31.8112C1.63905 31.5096 1.48149 31.1038 1.50174 30.6769C1.53997 29.8705 2.23437 29.25 3.04173 29.25H5.25C5.66421 29.25 6 28.9142 6 28.5V9.75H16.1894L13.902 12.0374C13.8299 11.9015 13.7608 11.7636 13.6949 11.6238C13.5273 11.2682 13.1184 11.0973 12.7514 11.2381L12.7402 11.2423C12.3342 11.3981 12.1509 11.8659 12.3357 12.2595C12.4772 12.5608 12.6317 12.8549 12.7981 13.1412L8.32919 17.6102C7.36591 18.1297 6.75 19.1496 6.75 20.25C6.75 20.9833 7.0204 21.6884 7.5 22.2325L7.5 26.9742C7.5 27.2879 7.6813 27.583 7.97337 27.6973C8.06447 27.733 8.15802 27.7501 8.25005 27.75C8.51427 27.75 8.7653 27.6099 8.90117 27.3721L11.6413 22.5773C11.9492 22.327 12.2047 22.0171 12.3917 21.6689L16.8592 17.2014C18.5672 18.1976 20.4989 18.7212 22.5 18.7212C24.5011 18.7212 26.4328 18.1976 28.1408 17.2014L32.6068 21.6674C33.1135 22.6087 34.1082 23.25 35.25 23.25C36.1454 23.25 36.9498 22.8552 37.5 22.2312V24.75C37.5 24.7642 37.5014 24.778 37.5021 24.792C37.5026 24.8003 37.5026 24.8087 37.5034 24.8171C37.506 24.8467 37.5101 24.8758 37.516 24.9043C37.5161 24.9046 37.5162 24.9049 37.5163 24.9051C37.5223 24.9338 37.5304 24.9617 37.5396 24.9891C37.5417 24.9954 37.5442 25.0016 37.5464 25.0078C37.5547 25.0304 37.564 25.0525 37.5744 25.074C37.5762 25.0777 37.5773 25.0817 37.5792 25.0854L39.0695 28.066C39.1709 28.2689 39.3519 28.4266 39.5726 28.479C39.9216 28.5621 40.2677 28.3918 40.4208 28.0854L41.9208 25.0854C41.9227 25.0817 41.9238 25.0777 41.9256 25.074C41.936 25.0525 41.9453 25.0304 41.9536 25.0078C41.9558 25.0016 41.9583 24.9954 41.9604 24.9891C41.9696 24.9617 41.9777 24.9338 41.9837 24.9051C41.9838 24.9049 41.9839 24.9046 41.984 24.9043C41.9899 24.8758 41.994 24.8467 41.9966 24.8171C41.9974 24.8087 41.9974 24.8003 41.9979 24.792C41.9986 24.778 42 24.7642 42 24.75V15.75C42 15.3358 41.6642 15 41.25 15H38.25C37.8358 15 37.5 15.3358 37.5 15.75V18.2688C37.2647 18.0019 36.9831 17.7767 36.6674 17.6068L32.2019 13.1412C32.3683 12.8549 32.5228 12.5608 32.6643 12.2595C32.8491 11.8659 32.6658 11.3981 32.2598 11.2423L32.2486 11.2381C31.8816 11.0973 31.4727 11.2682 31.3051 11.6238C31.2392 11.7636 31.1701 11.9015 31.098 12.0374L28.8106 9.75H43.5V32.25ZM40.5 24H39V16.5H40.5V24ZM40.0365 25.5L39.75 26.0729L39.4635 25.5H40.0365Z"
                        fill="black">
                      </path>
                    </svg>
                  </div>
                  <h3>
                    Kiến trúc sư</h3>
                </li>
                <li class="react-tabs__tab" v-on:click="tab = 2"
                  v-bind:class="{ 'react-tabs__tab--selected': tab == 2 }" role="tab" id="react-tabs-468182"
                  aria-selected="false" aria-disabled="false" aria-controls="react-tabs-468183">
                  <div class="svg_wrapper">
                    <svg width="42" height="45" viewBox="0 0 42 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M38.3158 0.736847H13.2632C11.6355 0.736847 10.3158 2.05653 10.3158 3.68422V28V34.6316V40.5263C10.3158 42.154 11.6355 43.4737 13.2632 43.4737H38.3158C39.9435 43.4737 41.2632 42.154 41.2632 40.5263V3.68422C41.2632 2.05653 39.9435 0.736847 38.3158 0.736847Z"
                        fill="#59AAE2">
                      </path>
                      <path d="M13.2632 3.6842H38.3158V37.5789H13.2632V3.6842Z" fill="white">
                      </path>
                      <path
                        d="M0.736843 8.10527V11.0526V12.5263V42C0.736843 42.8142 1.39632 43.4737 2.21053 43.4737C3.02474 43.4737 3.68421 42.8142 3.68421 42V8.10527L2.21053 5.1579L0.736843 8.10527Z"
                        fill="#59AAE2">
                      </path>
                      <path d="M19.1579 11.0526V13.2632H20.6316V15.4737H30.9474V13.2632H32.4211V11.0526H19.1579Z"
                        fill="#F8CC91">
                      </path>
                      <path d="M20.6316 15.4737H30.9474V18.421H20.6316V15.4737Z" fill="#F8CC91">
                      </path>
                      <path
                        d="M2.21053 43.4737C3.02474 43.4737 3.68421 42.8142 3.68421 42V38.3158H0.736843V42C0.736843 42.8142 1.39632 43.4737 2.21053 43.4737Z"
                        fill="#F9DA55">
                      </path>
                      <path d="M30.9474 15.4737V18.421H33.8947V13.2632H32.4211H30.9474V15.4737Z" fill="#F8CC91">
                      </path>
                      <path d="M20.6316 13.2632H19.1579H17.6842V18.421H20.6316V15.4737V13.2632Z" fill="#F8CC91">
                      </path>
                      <path d="M33.8947 22.8421H23.5789V25.7895H28.7368H33.8947V22.8421Z" fill="#904C2A">
                      </path>
                      <path d="M16.7396 31.3851L17.5619 34.5763L20.6316 28L13.6935 30.128L16.7396 31.3851Z"
                        fill="#F9DA55">
                      </path>
                      <path
                        d="M9.57895 40.5263C9.57895 42.5578 11.2317 44.2105 13.2632 44.2105H38.3158C40.3473 44.2105 42 42.5578 42 40.5263V3.68421C42 1.65274 40.3473 0 38.3158 0H13.2632C11.2317 0 9.57895 1.65274 9.57895 3.68421V28H11.0526V3.68421C11.0526 2.46547 12.0444 1.47368 13.2632 1.47368H38.3158C39.5345 1.47368 40.5263 2.46547 40.5263 3.68421V40.5263C40.5263 41.7451 39.5345 42.7368 38.3158 42.7368H13.2632C12.0444 42.7368 11.0526 41.7451 11.0526 40.5263V34.6316H9.57895V40.5263Z"
                        fill="black">
                      </path>
                      <path
                        d="M12.5263 37.579C12.5263 37.9857 12.8564 38.3158 13.2632 38.3158H38.3158C38.7225 38.3158 39.0526 37.9857 39.0526 37.579V3.68421C39.0526 3.27748 38.7225 2.94737 38.3158 2.94737H13.2632C12.8564 2.94737 12.5263 3.27748 12.5263 3.68421V28H14V4.42106H37.5789V36.8421H14V34.6316H12.5263V37.579Z"
                        fill="black">
                      </path>
                      <path d="M22.1053 39.7895H29.4737V41.2632H22.1053V39.7895Z" fill="black">
                      </path>
                      <path
                        d="M0 12.5263V42C0 43.2187 0.991789 44.2105 2.21053 44.2105C3.42926 44.2105 4.42105 43.2187 4.42105 42V8.10526C4.42105 7.99105 4.39453 7.87758 4.34368 7.77589L2.87 4.82853C2.62021 4.32895 1.80158 4.32895 1.55179 4.82853L0.0781052 7.77589C0.0265263 7.87758 0 7.99105 0 8.10526V11.0526H1.47368V8.27916L2.21053 6.80547L2.94737 8.27916V37.5789H1.47368V12.5263H0ZM2.94737 39.0526V42C2.94737 42.406 2.61653 42.7368 2.21053 42.7368C1.80453 42.7368 1.47368 42.406 1.47368 42V39.0526H2.94737Z"
                        fill="black">
                      </path>
                      <path d="M2.94737 0H2.21052C1.80379 0 1.47368 0.330105 1.47368 0.736842V1.47368H2.94737V0Z"
                        fill="black">
                      </path>
                      <path
                        d="M8.70432 32.4829L9.48832 31.2355C9.15968 31.0292 8.87895 30.7646 8.65421 30.45L7.45537 31.3077C7.79284 31.7785 8.21284 32.1742 8.70432 32.4829Z"
                        fill="black">
                      </path>
                      <path d="M6.63158 10.8596H8.10526V12.3001H6.63158V10.8596Z" fill="black">
                      </path>
                      <path d="M6.63158 7.97926H8.10526V9.41979H6.63158V7.97926Z" fill="black">
                      </path>
                      <path d="M6.63158 13.7399H8.10526V15.1804H6.63158V13.7399Z" fill="black">
                      </path>
                      <path
                        d="M8.10526 28.1429H6.63158V28.7368C6.63158 29.0758 6.6699 29.414 6.74653 29.7419L8.1819 29.4081C8.13105 29.19 8.10526 28.9638 8.10526 28.7368V28.1429Z"
                        fill="black">
                      </path>
                      <path
                        d="M6.11579 0.728743C5.63021 0.408217 5.09453 0.190112 4.52421 0.0803223L4.24569 1.52674C4.62442 1.59969 4.98105 1.74485 5.30379 1.9578L6.11579 0.728743Z"
                        fill="black">
                      </path>
                      <path d="M6.63158 16.6209H8.10526V18.0615H6.63158V16.6209Z" fill="black">
                      </path>
                      <path
                        d="M6.12095 2.76243C6.33905 3.08295 6.49011 3.43664 6.56895 3.81464L8.01169 3.51253C7.89232 2.94443 7.66611 2.41316 7.33821 1.93201L6.12095 2.76243Z"
                        fill="black">
                      </path>
                      <path
                        d="M11.8705 33.1579V31.6842H11.0541C10.8854 31.6842 10.7181 31.6695 10.5567 31.6422L10.3099 33.0953C10.5516 33.1365 10.8014 33.1579 11.0526 33.1579H11.8705Z"
                        fill="black">
                      </path>
                      <path d="M13.3103 31.6842H14.7508V33.1579H13.3103V31.6842Z" fill="black">
                      </path>
                      <path d="M6.63158 5.09821H8.10526V6.53873H6.63158V5.09821Z" fill="black">
                      </path>
                      <path d="M6.63158 19.5013H8.10526V20.9418H6.63158V19.5013Z" fill="black">
                      </path>
                      <path d="M6.63158 22.3816H8.10526V23.8221H6.63158V22.3816Z" fill="black">
                      </path>
                      <path d="M6.63158 25.2619H8.10526V26.7024H6.63158V25.2619Z" fill="black">
                      </path>
                      <path
                        d="M36.1053 9.57894V6.63157C36.1053 6.22483 35.7752 5.89473 35.3684 5.89473H32.4211V7.36841H34.6316V9.57894H36.1053Z"
                        fill="black">
                      </path>
                      <path
                        d="M15.4737 6.63157V9.57894H16.9474V7.36841H19.1579V5.89473H16.2105C15.8038 5.89473 15.4737 6.22483 15.4737 6.63157Z"
                        fill="black">
                      </path>
                      <path
                        d="M19.1579 10.3158C18.7512 10.3158 18.4211 10.6459 18.4211 11.0526V12.5263H17.6842C17.2775 12.5263 16.9474 12.8564 16.9474 13.2632V18.4211C16.9474 18.8278 17.2775 19.1579 17.6842 19.1579H20.6316H30.9474H33.8947C34.3015 19.1579 34.6316 18.8278 34.6316 18.4211V13.2632C34.6316 12.8564 34.3015 12.5263 33.8947 12.5263H33.1579V11.0526C33.1579 10.6459 32.8278 10.3158 32.4211 10.3158H19.1579ZM19.8947 17.6842H18.4211V14H19.8947V17.6842ZM21.3684 16.2105H30.2105V17.6842H21.3684V16.2105ZM33.1579 17.6842H31.6842V14H33.1579V17.6842ZM30.9474 12.5263C30.5406 12.5263 30.2105 12.8564 30.2105 13.2632V14.7368H21.3684V13.2632C21.3684 12.8564 21.0383 12.5263 20.6316 12.5263H19.8947V11.7895H31.6842V12.5263H30.9474Z"
                        fill="black">
                      </path>
                      <path
                        d="M34.6316 25.7895V22.8421C34.6316 22.4354 34.3015 22.1053 33.8947 22.1053H23.5789C23.1722 22.1053 22.8421 22.4354 22.8421 22.8421V25.7895C22.8421 26.1962 23.1722 26.5263 23.5789 26.5263H26.9581L25.2685 28.2159L26.3104 29.2578L28.7368 26.8314L31.1633 29.2578L32.2052 28.2159L30.5156 26.5263H33.8947C34.3015 26.5263 34.6316 26.1962 34.6316 25.7895ZM33.1579 25.0526H24.3158V23.5789H33.1579V25.0526Z"
                        fill="black">
                      </path>
                      <path
                        d="M12.9574 30.0934C12.9426 30.4043 13.1254 30.6909 13.4127 30.8088L16.1184 31.9252L16.8494 34.7598C16.9267 35.0612 17.1854 35.2815 17.4948 35.3095C17.5177 35.3117 17.5405 35.3124 17.5634 35.3124C17.8471 35.3124 18.1086 35.1481 18.2309 34.8873L21.3006 28.3109C21.4237 28.0472 21.3795 27.7355 21.1886 27.5159C20.9978 27.2963 20.6949 27.2086 20.4164 27.2948L13.4783 29.4228C13.1799 29.5149 12.9721 29.7832 12.9574 30.0934ZM19.2625 29.1907L17.7631 32.4034L17.4528 31.2008C17.3946 30.9761 17.2347 30.7919 17.0203 30.7035L15.8723 30.2297L19.2625 29.1907Z"
                        fill="black">
                      </path>
                    </svg>
                  </div>
                  <h3>
                    Thiết kế nội thất</h3>
                </li>
                <li class="react-tabs__tab" v-on:click="tab = 3"
                  v-bind:class="{ 'react-tabs__tab--selected': tab == 3 }" role="tab" id="react-tabs-468184"
                  aria-selected="false" aria-disabled="false" aria-controls="react-tabs-468185">
                  <div class="svg_wrapper">
                    <svg width="46" height="42" viewBox="0 0 46 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14 3.1111H31.1111V42H14V3.1111Z" fill="#FDBD40">
                      </path>
                      <path d="M20.2222 32.6667H24.8889V42H20.2222V32.6667Z" fill="#5A6470">
                      </path>
                      <path d="M0 20.2222H14V40.4444H0V20.2222Z" fill="#A7C6D3">
                      </path>
                      <path d="M1.55556 10.8889H10.8889V20.2222H1.55556V10.8889Z" fill="#CFDFE8">
                      </path>
                      <path d="M3.1111 5.44446H9.33332V10.8889H3.1111V5.44446Z" fill="#A7C6D3">
                      </path>
                      <path d="M5.44446 0H7.00001V5.44444H5.44446V0Z" fill="#5A6470">
                      </path>
                      <path d="M31.1111 20.2222H45.1111V40.4444H31.1111V20.2222Z" fill="#E9686A">
                      </path>
                      <path d="M43.5555 20.2222H34.2222V5.44446L43.5555 8.55557V20.2222Z" fill="#F98C96">
                      </path>
                      <path d="M36.5555 10.1111H38.1111V20.2222H36.5555V10.1111Z" fill="#5A6470">
                      </path>
                      <path d="M39.6667 10.1111H41.2222V20.2222H39.6667V10.1111Z" fill="#5A6470">
                      </path>
                      <path d="M2.33331 22.5555H11.6666V24.1111H2.33331V22.5555Z" fill="#5A6470">
                      </path>
                      <path d="M2.33331 25.6667H11.6666V27.2222H2.33331V25.6667Z" fill="#5A6470">
                      </path>
                      <path d="M2.33331 28.7778H11.6666V30.3333H2.33331V28.7778Z" fill="#5A6470">
                      </path>
                      <path d="M2.33331 31.8889H11.6666V33.4444H2.33331V31.8889Z" fill="#5A6470">
                      </path>
                      <path d="M17.8889 7.77777H21V10.8889H17.8889V7.77777Z" fill="#5A6470">
                      </path>
                      <path d="M24.1111 7.77777H27.2222V10.8889H24.1111V7.77777Z" fill="#5A6470">
                      </path>
                      <path d="M17.8889 14H21V17.1111H17.8889V14Z" fill="#5A6470">
                      </path>
                      <path d="M24.1111 14H27.2222V17.1111H24.1111V14Z" fill="#5A6470">
                      </path>
                      <path d="M17.8889 20.2222H21V23.3333H17.8889V20.2222Z" fill="#5A6470">
                      </path>
                      <path d="M24.1111 20.2222H27.2222V23.3333H24.1111V20.2222Z" fill="#5A6470">
                      </path>
                      <path d="M17.8889 26.4444H21V29.5556H17.8889V26.4444Z" fill="#5A6470">
                      </path>
                      <path d="M24.1111 26.4444H27.2222V29.5556H24.1111V26.4444Z" fill="#5A6470">
                      </path>
                      <path d="M35.7778 35.7778H40.4444V40.4444H35.7778V35.7778Z" fill="#5A6470">
                      </path>
                      <path d="M33.4444 22.5555H35V24.1111H33.4444V22.5555Z" fill="#5A6470">
                      </path>
                      <path d="M36.5555 22.5555H39.6667V24.1111H36.5555V22.5555Z" fill="#5A6470">
                      </path>
                      <path d="M41.2222 22.5555H42.7778V24.1111H41.2222V22.5555Z" fill="#5A6470">
                      </path>
                      <path d="M33.4444 25.6667H35V27.2222H33.4444V25.6667Z" fill="#5A6470">
                      </path>
                      <path d="M36.5555 25.6667H39.6667V27.2222H36.5555V25.6667Z" fill="#5A6470">
                      </path>
                      <path d="M41.2222 25.6667H42.7778V27.2222H41.2222V25.6667Z" fill="#5A6470">
                      </path>
                      <path d="M33.4444 28.7778H35V30.3333H33.4444V28.7778Z" fill="#5A6470">
                      </path>
                      <path d="M36.5555 28.7778H39.6667V30.3333H36.5555V28.7778Z" fill="#5A6470">
                      </path>
                      <path d="M41.2222 28.7778H42.7778V30.3333H41.2222V28.7778Z" fill="#5A6470">
                      </path>
                      <path d="M33.4444 31.8889H35V33.4444H33.4444V31.8889Z" fill="#5A6470">
                      </path>
                      <path d="M36.5555 31.8889H39.6667V33.4444H36.5555V31.8889Z" fill="#5A6470">
                      </path>
                      <path d="M41.2222 31.8889H42.7778V33.4444H41.2222V31.8889Z" fill="#5A6470">
                      </path>
                    </svg>
                  </div>
                  <h3>
                    Nhà phát triển bất động sản</h3>
                </li>
                <li class="react-tabs__tab" v-on:click="tab = 4"
                  v-bind:class="{ 'react-tabs__tab--selected': tab == 4 }" role="tab" id="react-tabs-468186"
                  aria-selected="false" aria-disabled="false" aria-controls="react-tabs-468187">
                  <div class="svg_wrapper">
                    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M42.1599 5.54314H0.839844V38.795H42.1599V5.54314Z" fill="#C9F3FF">
                      </path>
                      <path
                        d="M34.3724 24.2517C34.3724 24.2517 34.4616 21.383 36.8982 20.1606L37.7999 19.7087C37.1034 21.222 36.7428 22.868 36.7428 24.5338V24.6697L35.6481 26.3567L34.3724 24.2517Z"
                        fill="#D8FB93">
                      </path>
                      <path
                        d="M35.3487 28.1275C35.3487 25.4224 33.795 22.9578 31.3542 21.7913L30.0414 21.1639L30.1291 21.3233C31.3083 23.4667 32.1198 25.7827 32.5391 28.1751L34.3721 31.9972L35.3487 28.1275Z"
                        fill="#62CD4D">
                      </path>
                      <path
                        d="M33.8083 31.9972C33.8083 29.7286 32.5053 27.5028 30.4585 26.5245L29.3576 25.9984L29.4311 26.132C30.4189 27.9275 31.0991 29.9932 31.451 31.9971H33.8082V31.9972H33.8083Z"
                        fill="#A0E557">
                      </path>
                      <path
                        d="M34.8747 31.9972V31.5917C34.8747 27.4672 36.8472 23.5914 40.1819 21.164L40.1794 21.1694C38.577 23.9629 37.5283 28.6012 37.5283 31.9972H34.8747Z"
                        fill="#A0E557">
                      </path>
                      <path d="M42.1591 0.840088H0.839844V5.54305H42.1591V0.840088Z" fill="white">
                      </path>
                      <path
                        d="M37.8141 42.1591H31.0536C30.5086 42.1591 30.0667 41.7172 30.0667 41.1722V32.0812H38.8009V41.1722C38.8009 41.7172 38.3591 42.1591 37.8141 42.1591Z"
                        fill="#FFB954">
                      </path>
                      <path
                        d="M21.498 1.67969C21.7189 1.67969 21.9355 1.58982 22.0918 1.43361C22.2479 1.2774 22.3378 1.06072 22.3378 0.839844C22.3378 0.618965 22.248 0.402285 22.0918 0.246074C21.9355 0.0898633 21.7189 0 21.498 0C21.2771 0 21.0604 0.0898633 20.9042 0.246074C20.7481 0.402285 20.6581 0.618965 20.6581 0.839844C20.6581 1.06072 20.748 1.2774 20.9042 1.43361C21.0604 1.58982 21.2772 1.67969 21.498 1.67969Z"
                        fill="black">
                      </path>
                      <path
                        d="M15.8863 11.3032C15.6654 11.3032 15.4488 11.3931 15.2917 11.5493C15.1356 11.7055 15.0465 11.9222 15.0465 12.1431C15.0465 12.3639 15.1356 12.5806 15.2917 12.7377C15.4488 12.8939 15.6646 12.9829 15.8863 12.9829C16.1073 12.9829 16.3239 12.8939 16.4801 12.7377C16.6363 12.5806 16.7262 12.3639 16.7262 12.1431C16.7262 11.9222 16.6364 11.7055 16.4801 11.5493C16.323 11.3931 16.1073 11.3032 15.8863 11.3032Z"
                        fill="black">
                      </path>
                      <path
                        d="M12.9722 13.8695L5.4873 21.3544C5.15934 21.6824 5.15934 22.2142 5.4873 22.5422C5.65132 22.7062 5.86624 22.7882 6.08116 22.7882C6.29607 22.7882 6.51099 22.7062 6.67501 22.5422L14.1599 15.0573C14.4879 14.7293 14.4879 14.1975 14.1599 13.8695C13.8318 13.5415 13.3003 13.5415 12.9722 13.8695Z"
                        fill="black">
                      </path>
                      <path
                        d="M39.6407 39.6344H42.1602C42.6239 39.6344 43 39.2583 43 38.7946V5.54288C43 5.53524 42.9991 5.52777 42.9988 5.52013V0.839844C42.9988 0.375998 42.6227 0 42.159 0H25.7812C25.3174 0 24.9413 0.375998 24.9413 0.839844C24.9413 1.30369 25.3174 1.67969 25.7812 1.67969H41.3191V4.70304H1.6796V1.67969H17.5207C17.9844 1.67969 18.3605 1.30369 18.3605 0.839844C18.3605 0.375998 17.9844 0 17.5207 0H0.839844C0.376082 0 0 0.375998 0 0.839844V5.5428V38.7945C0 39.2582 0.376082 39.6343 0.839844 39.6343H29.227V41.1723C29.227 41.2219 29.2295 41.2708 29.2334 41.3193H12.1436C11.6798 41.3193 11.3037 41.6954 11.3037 42.1591C11.3037 42.6229 11.6798 42.999 12.1436 42.999H42.1602C42.6239 42.999 43 42.6229 43 42.1591C43 41.6954 42.6239 41.3193 42.1602 41.3193H39.6342C39.6381 41.2708 39.6407 41.2219 39.6407 41.1723V39.6344ZM32.1607 31.2413C31.9346 30.1438 31.6243 29.0718 31.2377 28.0546C32.1267 28.8643 32.7331 30.0077 32.9121 31.2413H32.1607ZM35.9142 24.6659C35.8111 24.8427 35.713 25.0223 35.6179 25.2035C35.4982 24.9068 35.3606 24.6182 35.2064 24.3388C35.2084 24.3199 35.2109 24.301 35.2116 24.2816C35.2146 24.2059 35.2844 22.8007 36.2288 21.7206C36.0136 22.6434 35.9028 23.591 35.9028 24.534C35.9029 24.5789 35.9074 24.6228 35.9142 24.6659ZM34.5075 28.0336C34.3751 28.5246 34.2696 29.024 34.1922 29.5296C33.9781 28.9623 33.6937 28.425 33.3482 27.9343C33.049 26.2685 32.5711 24.6492 31.9188 23.0973C33.4941 24.2275 34.4771 26.0642 34.5075 28.0336ZM37.7887 24.8368C37.1827 26.9035 36.7852 29.1874 36.7044 31.2413H35.7211C35.7888 28.9355 36.5209 26.7142 37.7887 24.8368ZM1.6796 35.8481L17.3262 20.2015C17.6542 19.8736 17.6542 19.3418 17.3262 19.0137C16.9982 18.6858 16.4666 18.6858 16.1384 19.0137L1.6796 33.4726V6.38264H20.6607V37.9547H1.6796V35.8481ZM22.3404 37.9547V6.38264H41.3204V37.9547H39.6408V32.0812C39.6408 31.6174 39.2647 31.2413 38.8009 31.2413H38.3856C38.5286 27.9492 39.5647 23.9287 40.9079 21.5872C40.9193 21.5674 40.9324 21.5417 40.9421 21.5209C41.1051 21.1739 41.0123 20.7604 40.7167 20.5163C40.421 20.2721 39.9976 20.2591 39.6877 20.4848C39.0322 20.9619 38.426 21.4933 37.8728 22.0698C38.0364 21.3781 38.267 20.7023 38.5629 20.0598C38.7119 19.7358 38.6402 19.3529 38.3839 19.1049C38.1275 18.857 37.7426 18.7979 37.4236 18.9577L36.5217 19.4097C34.9734 20.1864 34.2275 21.4984 33.8675 22.5579C33.2497 21.9402 32.5261 21.4204 31.7165 21.0335L30.4037 20.406C30.0745 20.2486 29.6814 20.3219 29.4309 20.5871C29.1805 20.8523 29.1298 21.249 29.3057 21.5686L29.3934 21.7279C30.1317 23.0698 30.719 24.4793 31.1515 25.9387C31.0428 25.8784 30.9329 25.8203 30.8205 25.7667L29.7196 25.2405C29.3903 25.0833 28.9971 25.1564 28.7468 25.4217C28.4963 25.687 28.4458 26.0837 28.6218 26.4033L28.6952 26.5367C29.4665 27.9388 30.0633 29.5501 30.4427 31.2413H30.0666C29.6028 31.2413 29.2267 31.6173 29.2267 32.0811V37.9546L22.3404 37.9547ZM31.0536 41.3192C30.9725 41.3192 30.9066 41.2533 30.9066 41.1722V32.921H37.9611V41.1722C37.9611 41.2533 37.8952 41.3192 37.8141 41.3192H31.0536Z"
                        fill="black">
                      </path>
                      <path
                        d="M8.24231 41.3192C8.02143 41.3192 7.80475 41.409 7.64854 41.5653C7.49149 41.7215 7.40247 41.9382 7.40247 42.1591C7.40247 42.3799 7.49149 42.5966 7.64854 42.7527C7.80475 42.909 8.02143 42.9989 8.24231 42.9989C8.46319 42.9989 8.67987 42.909 8.83608 42.7527C8.99221 42.5966 9.08215 42.3799 9.08215 42.1591C9.08215 41.9382 8.99229 41.7215 8.83608 41.5653C8.67903 41.409 8.4631 41.3192 8.24231 41.3192Z"
                        fill="black">
                      </path>
                    </svg>
                  </div>
                  <h3>
                    Công ty cửa và cửa sổ</h3>
                </li>
                <li class="react-tabs__tab" v-on:click="tab = 5"
                  v-bind:class="{ 'react-tabs__tab--selected': tab == 5 }" role="tab" id="react-tabs-468188"
                  aria-selected="false" aria-disabled="false" aria-controls="react-tabs-468189">
                  <div class="svg_wrapper">
                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M31.9873 12.4521C32.5433 10.8032 33.998 9.57308 35.7702 9.33758L36.9617 6.54814L32.862 2.4496L30.4453 4.02256C29.5271 3.50542 28.5559 3.10282 27.5474 2.82044L26.9505 0H21.0503L20.4534 2.82044C19.4448 3.10282 18.4729 3.50542 17.5554 4.02256L15.1387 2.4496L11.0425 6.54587L12.2113 9.33039C13.988 9.56742 15.4151 10.8587 15.9863 12.5251L16.2581 11.9304C17.6447 8.9157 20.6832 6.96774 24 6.96774C27.2873 6.96774 30.3153 8.89075 31.7132 11.8684L31.9873 12.4521Z"
                        fill="#F0BC5E">
                      </path>
                      <path
                        d="M30.3576 21.1138L27.096 20.2976V19.9268C28.5389 18.9197 29.4194 17.256 29.4194 15.4839V14.1305C29.4194 11.123 27.0628 8.6061 24.1663 8.5184C22.6822 8.47114 21.2873 9.01626 20.2266 10.046C19.1651 11.0757 18.5806 12.4567 18.5806 13.9355V15.4839C18.5806 17.256 19.4603 18.919 20.9032 19.926V20.2976L17.6424 21.1138C15.916 21.5451 14.7097 23.0897 14.7097 24.8695V26.2368L16.8697 25.7567C17.4923 25.6179 18.1285 25.5484 18.7655 25.5484C19.669 25.5484 20.5672 25.6886 21.4272 25.9635L24.9715 27.0968C25.3541 27.0968 25.7351 27.1501 26.1026 27.2555L30.9677 28.6452H31.7419L33.2903 27.8298V24.8695C33.2903 23.0897 32.084 21.5451 30.3576 21.1138Z"
                        fill="#F0BC5E">
                      </path>
                      <path
                        d="M48 20.129H46.2603L43.6675 21.4933C43.3756 21.3323 43.0721 21.1958 42.7447 21.1138L39.4831 20.2976V19.9268C40.926 18.9197 41.8064 17.2561 41.8064 15.4839V14.1306C41.8064 11.123 39.4498 8.60611 36.5534 8.5184C35.0716 8.47493 33.6744 9.01626 32.6137 10.046C31.5522 11.0757 30.9677 12.4567 30.9677 13.9355V15.4839C30.9677 17.2561 31.8474 18.919 33.2903 19.926V20.2976L30.1935 21.073L30.3576 21.1138C31.0747 21.2926 31.6939 21.6714 32.1816 22.1715L34.8387 21.5077V19.0558L34.4524 18.8324C33.2578 18.1418 32.5161 16.858 32.5161 15.4839V13.9355C32.5161 12.8797 32.9335 11.8923 33.6922 11.157C34.4501 10.4221 35.4556 10.026 36.5069 10.0668C38.5751 10.1288 40.2581 11.952 40.2581 14.1306V15.4839C40.2581 16.858 39.5156 18.1418 38.3203 18.8339L37.9332 19.0577L37.9362 21.5077L41.8042 22.4739L31.5507 27.871H31.0762L26.3165 26.5108C25.9423 26.4046 25.5559 26.3611 25.1681 26.3464L21.6634 25.2263C20.0663 24.7145 18.3376 24.6381 16.7026 25.0003L12.2956 25.9797L12.3584 25.7605L12.3871 24.3296L8.30406 21.9477L10.0645 21.5077V19.0558L9.67817 18.8324C8.48362 18.1418 7.74194 16.858 7.74194 15.4839V13.9355C7.74194 12.8797 8.15927 11.8923 8.91797 11.157C9.67591 10.4221 10.6837 10.026 11.7327 10.0668C13.8009 10.1288 15.4839 11.952 15.4839 14.1306V15.4839C15.4839 16.858 14.7414 18.1418 13.5461 18.8339L13.159 19.0577L13.162 21.5077L15.8184 22.1715C16.3068 21.6714 16.9253 21.2926 17.6424 21.1138L17.8065 21.073L14.7089 20.2976V19.9268C16.1518 18.9197 17.0323 17.2561 17.0323 15.4839V14.1306C17.0323 11.123 14.6757 8.60611 11.7792 8.5184C10.2966 8.47493 8.9002 9.01626 7.83947 10.046C6.77797 11.0757 6.19355 12.4567 6.19355 13.9355V15.4839C6.19355 17.2561 7.07321 18.919 8.51613 19.926V20.2976L6.38861 20.8295L2.53238 18.5807H0V34.6229L7.61643 37.1613H9.0998L9.28503 36.5126L11.6197 37.9139C11.6579 39.1833 12.6759 40.2048 13.9442 40.2494C13.9888 41.5124 15.0038 42.5274 16.2668 42.572C16.3114 43.8349 17.3264 44.8499 18.5893 44.8945C18.6355 46.187 19.6939 47.2258 20.997 47.2258C21.4808 47.2258 21.9553 47.075 22.3541 46.8062L23.0398 47.4118C23.4696 47.7902 24.0231 48 24.5977 48H24.7409C26.0292 48 27.0775 46.9586 27.0938 45.6744C28.3681 45.6581 29.4001 44.6261 29.4163 43.3518C30.6914 43.3356 31.7242 42.302 31.7389 41.027C33.0257 40.9967 34.0645 39.9454 34.0645 38.6515C34.0645 38.5736 34.0607 38.4969 34.0528 38.4194L48 31.4463V20.129ZM1.54839 20.129H2.11278L7.6807 23.3766L4.87122 34.6142L1.54839 33.5062V20.129ZM7.86744 35.6129L6.34362 35.1052L9.07296 24.189L10.8387 25.2188V25.4399L7.93246 35.6129H7.86744ZM13.1613 37.8417C13.1613 37.6134 13.2535 37.3896 13.4153 37.2278L14.7762 35.8669C14.938 35.7051 15.1618 35.6129 15.3901 35.6129C15.8687 35.6129 16.2581 36.0023 16.2581 36.4809C16.2581 36.7092 16.1658 36.933 16.004 37.0948L14.6431 38.4557C14.4813 38.6174 14.2576 38.7097 14.0292 38.7097C13.5507 38.7097 13.1613 38.3203 13.1613 37.8417ZM15.4839 40.1643C15.4839 39.936 15.5761 39.7122 15.7379 39.5504L17.0988 38.1895C17.2606 38.0277 17.4844 37.9355 17.7127 37.9355C18.1913 37.9355 18.5806 38.3249 18.5806 38.8034C18.5806 39.0318 18.4884 39.2556 18.3266 39.4173L16.9657 40.7782C16.8039 40.94 16.5801 41.0323 16.3518 41.0323C15.8732 41.0323 15.4839 40.6429 15.4839 40.1643ZM17.8065 42.4869C17.8065 42.2586 17.8987 42.0348 18.0605 41.873L19.4214 40.5121C19.5832 40.3503 19.807 40.2581 20.0353 40.2581C20.5139 40.2581 20.9032 40.6474 20.9032 41.126C20.9032 41.3543 20.811 41.5781 20.6492 41.7399L19.2883 43.1008C19.1265 43.2626 18.9027 43.3548 18.6744 43.3548C18.1958 43.3548 17.8065 42.9655 17.8065 42.4869ZM20.997 45.6774C20.5184 45.6774 20.129 45.2881 20.129 44.8095C20.129 44.5812 20.2213 44.3574 20.3831 44.1956L21.744 42.8347C21.9057 42.6729 22.1295 42.5807 22.3579 42.5807C22.8364 42.5807 23.2258 42.97 23.2258 43.4486C23.2258 43.6769 23.1336 43.9007 22.9718 44.0625L21.6109 45.4234C21.4491 45.5852 21.2253 45.6774 20.997 45.6774ZM24.7409 46.4516H24.5977C24.4003 46.4516 24.2113 46.3798 24.0643 46.2494L23.4851 45.7387L24.0665 45.1573C24.2741 44.9497 24.4351 44.7029 24.5542 44.4379L25.2581 45.0238C25.4422 45.1773 25.5484 45.4034 25.5484 45.6442C25.5484 46.0895 25.1862 46.4516 24.7409 46.4516ZM31.6837 39.4839H31.5499C31.3556 39.4839 31.1658 39.4151 31.0173 39.2903L26.8189 35.7917L25.827 36.9817L29.904 40.3787C30.0873 40.5321 30.1935 40.7582 30.1935 40.999C30.1935 41.4443 29.8314 41.8065 29.3861 41.8065H29.2171C29.0292 41.8065 28.8455 41.7399 28.7007 41.619L24.4956 38.1151L23.5037 39.3051L27.5806 42.7024C27.7647 42.8547 27.871 43.0808 27.871 43.3216C27.871 43.7669 27.5088 44.129 27.0635 44.129C26.7664 44.129 26.4768 44.0236 26.2489 43.8342L24.5209 42.3939C24.1402 41.6159 23.3581 41.0735 22.4422 41.041C22.3976 39.778 21.3826 38.763 20.1196 38.7184C20.075 37.4554 19.06 36.4404 17.797 36.3958C17.7516 35.1033 16.6932 34.0645 15.3901 34.0645C14.7539 34.0645 14.1313 34.3223 13.6815 34.7722L12.3206 36.1331C12.2393 36.2143 12.172 36.3066 12.1036 36.3981L9.72543 34.971L11.8102 27.6744L17.0368 26.5124C18.4079 26.2058 19.8535 26.2723 21.1905 26.7002L22.331 27.065L18.4646 28.9982C17.5811 29.4409 17.0323 30.3296 17.0323 31.3178V31.4709C17.0323 32.901 18.1958 34.0645 19.6259 34.0645C20.0958 34.0645 20.5581 33.9368 20.9599 33.6944L23.8427 31.9657C24.4219 31.6187 25.1991 31.6947 25.6992 32.1445L32.2405 38.0315C32.4156 38.1903 32.5161 38.4156 32.5161 38.6515C32.5161 39.1108 32.143 39.4839 31.6837 39.4839ZM46.4516 30.4892L33.4086 37.0112C33.3663 36.9662 33.3221 36.9235 33.2756 36.8819L26.7354 30.995C26.1623 30.4778 25.4214 30.1936 24.6494 30.1936C24.0851 30.1936 23.5309 30.347 23.0455 30.6381L20.1615 32.3676C19.9997 32.4651 19.8149 32.5161 19.6259 32.5161C19.049 32.5161 18.5806 32.0478 18.5806 31.4709V31.3178C18.5806 30.919 18.8022 30.5614 19.1583 30.3833L23.4768 28.2241C24.2159 27.854 25.0932 27.7712 25.8897 28.0003L30.7549 29.3899L31.9332 29.4194L46.4516 21.778V30.4892Z"
                        fill="black">
                      </path>
                    </svg>
                  </div>
                  <h3>
                    Người tiêu dùng</h3>
                </li>
              </div>
            </ul>
            <div class="react-tabs__tab-panel react-tabs__tab-panel--selected" role="tabpanel" v-if="tab == 1">
              <div class="section_description content">

                <h4>
                  <strong>
                    Kiến trúc sư</strong>
                  | Hiện thực hóa công trình
                </h4>


                <p>
                  Tầm nhìn: CMECH là lựa chọn hàng đầu cho các kiến trúc sư danh tiếng thiết kế khách sạn và nhà ở
                  cao cấp. Phụ kiện CMECH mang lại hiệu ứng hoàn thiện để đáp ứng các yêu cầu hiệu suất và tạo nên
                  những thiết kế đạt giải thưởng.</p>

              </div>
            </div>
            <div class="react-tabs__tab-panel react-tabs__tab-panel--selected" role="tabpanel" v-if="tab == 2">
              <div class="section_description content">
                <h4 _msttexthash="17718558" _msthash="75"><strong _istranslated="1">Nhà thiết kế nội thất </strong>| Dấu
                  ấn theo xu hướng</h4>
                <p _msttexthash="478750454" _msthash="76">Các nhà thiết kế nội thất tìm đến phụ kiện CMECH để tạo nên
                  điểm nhấn hoàn hảo, đáp ứng các xu hướng thẩm mỹ mới nhất cho tác phẩm của họ. Với vẻ ngoài đơn giản
                  nhưng tinh tế, phụ kiện của chúng tôi làm nổi bật và hài hòa với những ý tưởng sáng tạo của các nhà
                  thiết kế nội thất hàng đầu thế giới.</p>
              </div>
            </div>


            <div class="react-tabs__tab-panel react-tabs__tab-panel--selected" role="tabpanel" v-if="tab == 3">
              <div class="section_description content">
                <h4 _msttexthash="24609793" _msthash="166"><strong _istranslated="1">Nhà phát triển bất động
                    sản</strong> | Dấu ấn đổi mới</h4>
                <p _msttexthash="902648162" _msthash="167">Việc tái phát triển các bất động sản cao cấp đòi hỏi những
                  quyết định táo bạo, nhưng các nhà phát triển bất động sản biết rằng không có rủi ro nào khi chọn phụ
                  kiện từ CMECH. Thương hiệu của chúng tôi mang đến sự đảm bảo về chất lượng mà họ cần để hoàn thành dự
                  án. Thật vậy, các thiết kế phụ kiện của chúng tôi đã góp phần nâng tầm các công trình cải tạo thuộc
                  hàng xa hoa nhất thế giới.</p>
              </div>
            </div>



            <div class="react-tabs__tab-panel react-tabs__tab-panel--selected" role="tabpanel" v-if="tab == 4">
              <div class="section_description content">
                <h4 _msttexthash="14308203" _msthash="168"><strong _istranslated="1">Công ty cựa và cựa sổ</strong> |
                  Gắn kết niềm tin</h4>
                <p _msttexthash="583647415" _msthash="169">Với 30 năm cung cấp dịch vụ chất lượng cho các công ty cửa và
                  cửa sổ, dấu ấn của CMECH chính là sự tin cậy. Các doanh nghiệp hàng đầu tiếp tục chọn CMECH cho nhu
                  cầu phụ kiện cửa và cửa sổ của họ vì họ biết rằng có thể tin tưởng vào chúng tôi về chất lượng lắp đặt
                  và dịch vụ.</p>
              </div>
            </div>



            <div class="react-tabs__tab-panel react-tabs__tab-panel--selected" role="tabpanel" v-if="tab == 5">
              <div class="section_description content">
                <h4><strong>Người tiêu dùng</strong></h4>
                <p>Dịch vụ khách hàng cá nhân hóa không phải là tất cả những gì
                  khiến khách hàng của chúng tôi cảm thấy thoải mái. Mọi thứ tại CMECH đều được thiết kế tỉ mỉ với sự
                  quan tâm đến khách hàng. Các thiết kế của chúng tôi kết hợp giữa chức năng và thẩm mỹ, mang đến cho
                  khách hàng những phụ kiện hoàn thiện ngôi nhà của họ và dễ dàng sử dụng. Chưa kể đến các khóa an ninh
                  nổi tiếng của chúng tôi, vượt qua các tiêu chuẩn an toàn. An ninh và phong cách: tất cả đều có tại
                  CMECH dành cho bạn.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
    <section class="Projects__RecentProjects-sc-18echsy-0 tMtBc">
      <div class="container_full">
        <div class="animated fadeInUp" style="animation-duration: 1s;">
          <div class="container_wide">
            <h3 class="section_subtitle">
              Dự án</h3>
            <h2 class="section_title">
              Nghiên cứu trường hợp</h2>
            <p class="section_description">
              Từ căn hộ cao cấp đến khách sạn sang trọng, CMECH dẫn đầu về đổi mới và thiết kế. Các nghiên cứu
              trường hợp của chúng tôi cho thấy cách CMECH cải thiện hiệu suất tòa nhà thông minh, thúc đẩy phát
              triển phụ kiện bền vững và tiết kiệm năng lượng, đồng thời đóng góp cho tương lai thiết kế thân thiện
              với môi trường.</p>
          </div>
        </div>
        <div class="animated fadeInUp" style="animation-duration: 1s;">
          <div class="projects_list">
            <div class="slider_projects glide--ltr glide--carousel glide--swipeable">
              <div class="glide__track" data-glide-el="track">
                <ul class="glide__slides"
                  style="transition: transform cubic-bezier(0.77, 0, 0.175, 1); width: 4985px; transform: translate3d(-1040.62px, 0px, 0px);">
                  <li class="glide__slide slide_projects glide__slide--clone"
                    style="width: 406.25px; margin-right: 5px;">
                    <router-link to="/project/maldives-lux-north-male-atoll">
                      <div class="image_wrap">
                        <img src="/uploads/maldives_2_opt_2d65f4ea69.jpg" alt="project featured">
                      </div>
                      <h5>
                        Khách sạn sang trọng Reefs<span>
                          |</span>
                        Maldives</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects glide__slide--clone"
                    style="width: 406.25px; margin-left: 5px; margin-right: 5px;">
                    <router-link to="/project/bangkok-ashton-asoke">
                      <div class="image_wrap">
                        <img src="/uploads/bangkok_opt_3_cecc63b636.jpg" alt="project featured">
                      </div>
                      <h5>
                        ASHTON ASOKE<span>
                          |</span>
                        Bangkok</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects glide__slide--clone"
                    style="width: 406.25px; margin-left: 5px; margin-right: 5px;">
                    <router-link to="/project/da-nang-the-ocean-suites">
                      <div class="image_wrap">
                        <img src="/uploads/da_nang_opt_1_b4008aafba.jpg" alt="project featured">
                      </div>
                      <h5>
                        The Ocean Suites<span>
                          |</span>
                        Đà Nẵng</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects glide__slide--clone is_visible"
                    style="width: 406.25px; margin-left: 5px; margin-right: 5px;">
                    <router-link to="/project/sanya-atlantis">
                      <div class="image_wrap">
                        <img src="/uploads/1_7449ec1be9_728733f169.png" alt="project featured">
                      </div>
                      <h5>
                        Khách sạn Atlantis<span>
                          |</span>
                        Tam Á</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects glide__slide--active"
                    style="width: 406.25px; margin-left: 5px; margin-right: 5px;">
                    <router-link to="/project/maldives-lux-north-male-atoll">
                      <div class="image_wrap">
                        <img src="/uploads/maldives_2_opt_2d65f4ea69.jpg" alt="project featured">
                      </div>
                      <h5>
                        Khách sạn sang trọng Reefs<span>
                          |</span>
                        Maldives</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects is_visible"
                    style="width: 406.25px; margin-left: 5px; margin-right: 5px;">
                    <router-link to="/project/bangkok-ashton-asoke">
                      <div class="image_wrap">
                        <img src="/uploads/bangkok_opt_3_cecc63b636.jpg" alt="project featured">
                      </div>
                      <h5>
                        ASHTON ASOKE<span>
                          |</span>
                        Bangkok</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects" style="width: 406.25px; margin-left: 5px; margin-right: 5px;">
                    <router-link to="/project/da-nang-the-ocean-suites">
                      <div class="image_wrap">
                        <img src="/uploads/da_nang_opt_1_b4008aafba.jpg" alt="project featured">
                      </div>
                      <h5>
                        The Ocean Suites<span>
                          |</span>
                        Đà Nẵng</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects" style="width: 406.25px; margin-left: 5px; margin-right: 5px;">
                    <router-link to="/project/sanya-atlantis">
                      <div class="image_wrap">
                        <img src="/uploads/1_7449ec1be9_728733f169.png" alt="project featured">
                      </div>
                      <h5>
                        Khách sạn Atlantis<span>
                          |</span>
                        Tam Á</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects glide__slide--clone"
                    style="width: 406.25px; margin-left: 5px; margin-right: 5px;">
                    <router-link to="/project/maldives-lux-north-male-atoll">
                      <div class="image_wrap">
                        <img src="/uploads/maldives_2_opt_2d65f4ea69.jpg" alt="project featured">
                      </div>
                      <h5>
                        Khách sạn sang trọng Reefs<span>
                          |</span>
                        Maldives</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects glide__slide--clone"
                    style="width: 406.25px; margin-left: 5px; margin-right: 5px;">
                    <router-link to="/project/bangkok-ashton-asoke">
                      <div class="image_wrap">
                        <img src="/uploads/bangkok_opt_3_cecc63b636.jpg" alt="project featured">
                      </div>
                      <h5>
                        ASHTON ASOKE<span>
                          |</span>
                        Bangkok</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects glide__slide--clone"
                    style="width: 406.25px; margin-left: 5px; margin-right: 5px;">
                    <router-link to="/project/da-nang-the-ocean-suites">
                      <div class="image_wrap">
                        <img src="/uploads/da_nang_opt_1_b4008aafba.jpg" alt="project featured">
                      </div>
                      <h5>
                        The Ocean Suites<span>
                          |</span>
                        Đà Nẵng</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                  <li class="glide__slide slide_projects glide__slide--clone"
                    style="width: 406.25px; margin-left: 5px;">
                    <router-link to="/project/sanya-atlantis">
                      <div class="image_wrap">
                        <img src="/uploads/1_7449ec1be9_728733f169.png" alt="project featured">
                      </div>
                      <h5>
                        Khách sạn Atlantis<span>
                          |</span>
                        Tam Á</h5>
                      <h4>
                      </h4>
                    </router-link>
                  </li>
                </ul>
                <div data-glide-el="controls" class="controls">
                  <button type="button" data-glide-dir="<" class="slide_left">
                    <svg version="1.1" id="leftarrow" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                      viewBox="0 0 512 512" xml:space="preserve">
                      <g>
                        <g>
                          <path
                            d="M492,236H68.442l70.164-69.824c7.829-7.792,7.859-20.455,0.067-28.284c-7.792-7.83-20.456-7.859-28.285-0.068 l-104.504,104c-0.007,0.006-0.012,0.013-0.018,0.019c-7.809,7.792-7.834,20.496-0.002,28.314c0.007,0.006,0.012,0.013,0.018,0.019 l104.504,104c7.828,7.79,20.492,7.763,28.285-0.068c7.792-7.829,7.762-20.492-0.067-28.284L68.442,276H492 c11.046,0,20-8.954,20-20C512,244.954,503.046,236,492,236z">
                          </path>
                        </g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                    </svg>
                  </button>
                  <button type="button" data-glide-dir=">
" class="slide_right">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                      viewBox="0 0 512 512" xml:space="preserve">
                      <g>
                        <g>
                          <path
                            d="M506.134,241.843c-0.006-0.006-0.011-0.013-0.018-0.019l-104.504-104c-7.829-7.791-20.492-7.762-28.285,0.068 c-7.792,7.829-7.762,20.492,0.067,28.284L443.558,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h423.557 l-70.162,69.824c-7.829,7.792-7.859,20.455-0.067,28.284c7.793,7.831,20.457,7.858,28.285,0.068l104.504-104 c0.006-0.006,0.011-0.013,0.018-0.019C513.968,262.339,513.943,249.635,506.134,241.843z">
                          </path>
                        </g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                      <g>
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="animated fadeInUp" style="animation-duration: 1s;">
          <div class="SiteButton__LinkWrapper-o4bfn9-0 iBTqZx link_wrapper">
            <router-link to="/projects">
              Đọc thêm</router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="Blog__BlogSection-a6xgsm-0 fYaBCk">
      <div class="container_wide">
        <div class="blog_wrapper">
          <div class="blog_heading">
            <div class="animated fadeInUp" style="animation-duration: 1s;">
              <h4 class="section_subtitle">
                Thông tin chi tiết</h4>
              <h2 class="section_title">
                Blog</h2>
              <p class="section_description content_center">
                Tìm hiểu về công nghệ phụ kiện cửa sổ và cửa hiện đại nhất trên blog CMECH. Các nhà thiết kế và kỹ
                sư hàng đầu trong ngành mang đến cho bạn giải pháp thiết kế nội thất sáng tạo.</p>
            </div>
          </div>
          <div class="animated fadeInUp" style="animation-duration: 1s;">
            <div class="blog_gallery">
              <div class="animated fadeInUp" style="animation-duration: 1s;">
                <div class="blog_slider glide--ltr glide--carousel glide--swipeable">
                  <swiper class="glide__slide slide_blog" :slidesPerView="auto" :loop="true" :spaceBetween="30"
                    :pagination="{
                      clickable: true,
                    }" :modules="modules">
                    <swiper-slide class="glide__slide slide_blog" v-for="blog in blogList" :key="blog">
                      <router-link :to="blog.link" class="permalink">
                        <div class="featured_image">
                          <img :src="blog.background" :alt="blog.title">
                        </div>
                        <h3>
                          {{ blog.title }}</h3>
                        <p>
                        </p>
                      </router-link>
                    </swiper-slide>
                  </swiper>
                </div>
              </div>
            </div>
          </div>
          <div class="SiteButton__LinkWrapper-o4bfn9-0 iBTqZx link_wrapper">
            <router-link to="/blog">
              Đọc thêm</router-link>
          </div>
        </div>
      </div>
    </section>
  </PublicTemplate>
</template>


<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { ref } from 'vue';

// Import Swiper styles
import 'swiper/css';

import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import required modules
import { Autoplay } from 'swiper/modules';
import { Pagination } from 'swiper/modules';
import { Navigation } from 'swiper/modules';
import PublicTemplate from '@/templates/PublicTemplate.vue';
const axios = require('axios').default;
export default {
  data() {
    return {
      isPlayVideo: false,
      tab: 1,
      blogList: []
    }
  },
  setup() {
    const progressCircle = ref(null);
    const progressContent = ref(null);
    const onAutoplayTimeLeft = (s, time, progress) => {
      progressCircle.value.style.setProperty('--progress', 1 - progress);
      progressContent.value.textContent = `${Math.ceil(time / 1000)}s`;
    };
    return {
      onAutoplayTimeLeft,
      progressCircle,
      progressContent,
      modules: [Pagination, Navigation, Autoplay],
    };
  },
  name: 'HomeView',
  async mounted() {
    window.scrollTo(0, 0);
    try {
      let res = await axios.get("/api/blog.json");
      if (res) {
        this.blogList = res.data;
      }
    } catch {
      console;
    }
  },
  components: {
    PublicTemplate,
    Swiper,
    SwiperSlide
  },
  methods: {
    playVideo() {
      let video = document.querySelector("video");
      if (video) {
        if (!this.isPlayVideo) {
          video.play();
        } else {
          video.pause();
        }
        this.isPlayVideo = !this.isPlayVideo;
      }
    }
  }
}
</script>


<style lang="less">
.fYaBCk .swiper-pagination {
  display: none;
}

.autoplay-progress {
  position: absolute;
  right: 16px;
  bottom: 16px;
  z-index: 10;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
}

.autoplay-progress svg {
  --progress: 0;
  position: absolute;
  left: 0;
  top: 0px;
  z-index: 10;
  width: 100%;
  height: 100%;
  stroke-width: 4px;
  stroke: white;
  fill: none;
  stroke-dashoffset: calc(125.6px * (1 - var(--progress)));
  stroke-dasharray: 125.6;
  transform: rotate(-90deg);
}

.fYaBCk .swiper-wrapper {
  .swiper-slide {
    width: 300px !important;


    a {
      text-decoration: none;
      color: inherit;
    }

    h3 {
      margin-top: 10px;
      font-size: 14px;
    }

    img {
      max-width: 100%;
    }
  }
}

.iBTqZx {
  margin-top: 50px;
  text-align: center;
  display: grid;
  place-items: center;
}

/*!sc*/
.iBTqZx a {
  font-size: 0.5em;
  -webkit-letter-spacing: 1.4px;
  -moz-letter-spacing: 1.4px;
  -ms-letter-spacing: 1.4px;
  letter-spacing: 1.4px;
  color: #050505;
  -webkit-text-decoration: none;
  text-decoration: none;
  padding: 15px 60px;
  border: 1px solid #0b0b0b;
  border-radius: 4px;
  text-transform: capitalize;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  display: inline;
  text-transform: uppercase;
}

/*!sc*/
@media (max-width:1024px) {
  .iBTqZx a {
    font-size: 0.7em;
    padding: 12px 50px;
  }
}

/*!sc*/
.iBTqZx a:hover {
  background: var(--brand_black);
  color: #fff;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
data-styled.g4[id="SiteButton__LinkWrapper-o4bfn9-0"] {
  content: "iBTqZx,"
}

/*!sc*/
.hWBHX {
  background: var(--brand_black);
  opacity: 0;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  overflow: hidden;
}

/*!sc*/
.hWBHX.fade_in {
  opacity: 1;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper {
  padding-top: 40px;
  padding-bottom: 40px;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper {
    padding-top: 50px;
    padding-bottom: 15px;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  -webkit-column-gap: 90px;
  column-gap: 90px;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
    grid-template-columns: 1fr;
  }
}

/*!sc*/
@media (max-width:480px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
    text-align: center;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
  margin-bottom: 55px;
  color: white;
  text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
    margin-bottom: 30px;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
  height: 34px;
  margin-right: 15px;
  fill: white;
  padding-top: 6px;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
    height: 26px;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap {
  margin-bottom: 35px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap p {
  color: #fff;
  text-align: left;
  margin-bottom: 15px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
  display: block;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
    padding-bottom: 60px;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
  place-items: left;
  display: block;
  text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
    place-items: center;
    text-align: center;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a {
  color: white;
  border: 1px solid white;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a:hover {
  color: var(--brand_black);
  background-color: white;
  -webkit-transform: translateY(-3px);
  -ms-transform: translateY(-3px);
  transform: translateY(-3px);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
  padding-top: 75%;
  display: block;
  -webkit-text-decoration: none;
  text-decoration: none;
  overflow: hidden;
  position: relative;
}

/*!sc*/
@media (max-width:1024px) {
  .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
    display: none;
  }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image img {
  height: 100%;
  display: block;
  position: absolute;
  object-fit: cover;
  object-position: center;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/*!sc*/
data-styled.g5[id="LearnHow__LearnHowWrap-bgqo87-0"] {
  content: "hWBHX,"
}

/*!sc*/
.fYaBCk {
  display: block;
  padding: 80px 0;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  overflow: hidden;
}

/*!sc*/
@media (max-width:768px) {
  .fYaBCk {
    padding-top: 60px;
    padding-bottom: 60px;
  }
}

/*!sc*/
.fYaBCk .container_wide {
  max-width: 100%;
}

/*!sc*/

.fYaBCk .container_wide .blog_wrapper .blog_heading p {
  margin-bottom: 60px;
}

/*!sc*/
@media (max-width:1024px) {
  .fYaBCk .container_wide .blog_wrapper .blog_heading p {
    margin-bottom: 40px;
  }
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery {
  padding-bottom: 60px;
  position: relative;
}

/*!sc*/
@media (max-width:1024px) {
  .fYaBCk .container_wide .blog_wrapper .blog_gallery {
    padding-bottom: 40px;
  }
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__track {
  position: relative;
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__track .controls button {
  position: absolute;
  background: #fff;
  top: 33%;
  left: 65px;
  border-radius: 50%;
  outline: none;
  width: 34px;
  height: 34px;
  padding-top: 5px;
  z-index: 100000;
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__track .controls button svg {
  display: block;
  width: 22px;
  height: 26px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/*!sc*/
@media (max-width:1024px) {
  .fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__track .controls button {
    left: 15px;
    top: 35%;
    padding-top: 5px;
  }
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__track .controls button.slide_right {
  left: auto;
  right: 65px;
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__track .controls button.slide_right svg {
  -webkit-transform: translate(-50%, -50%) rotate(180deg);
  -ms-transform: translate(-50%, -50%) rotate(180deg);
  transform: translate(-50%, -50%) rotate(180deg);
}

/*!sc*/
@media (max-width:1024px) {
  .fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__track .controls button.slide_right {
    right: 15px;
  }
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides {
  list-style-type: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
  position: relative;
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide {
  position: relative;
  opacity: 0.6;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide.is_visible,
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide.glide__slide--active {
  opacity: 1;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide .permalink {
  position: relative;
  -webkit-text-decoration: none;
  text-decoration: none;
  color: var(--brand_white);
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide .permalink .featured_image {
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
  border-radius: 4px;
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide .permalink .featured_image img {
  display: block;
  width: 100%;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide .permalink h3 {
  font-size: 0.6em;
  font-weight: 400;
  color: var(--brand_black);
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

/*!sc*/
@media (max-width:1024px) {
  .fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide .permalink h3 {
    font-size: 0.8em;
  }
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide .permalink p {
  font-size: 0.55em;
  font-weight: 300;
  color: var(--text_grey);
  width: 80%;
}

/*!sc*/
@media (max-width:768px) {
  .fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide .permalink p {
    font-size: 0.8em;
    width: 100%;
  }
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide .category {
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 0.5em;
  -webkit-text-decoration: none;
  text-decoration: none;
  background-color: white;
  color: var(--brand_black);
  padding: 6px 15px;
  border-radius: 12px;
  display: block;
  border: 1px solid white;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
@media (max-width:768px) {
  .fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide .category {
    font-size: 0.7em;
  }
}

/*!sc*/
.fYaBCk .container_wide .blog_wrapper .blog_gallery .animated .glide__slides .glide__slide .category:hover {
  background-color: var(--brand_black);
  color: white;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.fYaBCk .container_wide .link_wrapper {
  margin-top: 0;
}

/*!sc*/
data-styled.g6[id="Blog__BlogSection-a6xgsm-0"] {
  content: "fYaBCk,"
}

/*!sc*/
.hYNhoE {
  -webkit-transition: var(--transition);
  transition: var(--transition);
  overflow: hidden;
}

/*!sc*/
.hYNhoE .container {
  padding: 0 30px;
  text-align: center;
}

/*!sc*/
@media (max-width:1024px) {
  .hYNhoE .container {
    padding: 0 15px;
  }
}

/*!sc*/
.hYNhoE .container>p {
  margin-bottom: 50px;
}

/*!sc*/
@media (max-width:1024px) {
  .hYNhoE .container>p {
    margin-bottom: 30px;
  }
}

/*!sc*/
.hYNhoE .container ul {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}

/*!sc*/
@media (max-width:1024px) {
  .hYNhoE .container ul {
    grid-template-columns: repeat(12, 1fr);
    grid-auto-flow: dense;
  }
}

/*!sc*/
.hYNhoE .container ul li {
  list-style-type: none;
  border: 1px solid white;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
@media (max-width:1024px) {
  .hYNhoE .container ul li {
    grid-column: span 6;
    border: 1px solid #eeeeee;
  }

  .hYNhoE .container ul li:nth-of-type(3) {
    grid-column-start: 1;
    grid-column-end: 7;
  }
}

/*!sc*/
.hYNhoE .container ul li:hover {
  border: 1px solid #eeeeee;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05);
  -webkit-transition: var(--transition);
  transition: var(--transition);
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}

/*!sc*/
.hYNhoE .container ul li:hover a span:after {
  background-color: var(--brand_black);
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.hYNhoE .container ul li a {
  -webkit-text-decoration: none;
  text-decoration: none;
  display: block;
  width: 100%;
  height: 300px;
  position: relative;
  padding: 30px 15px;
  padding-bottom: 50px;
}

/*!sc*/
@media (max-width:1024px) {
  .hYNhoE .container ul li a {
    height: auto;
    padding: 25px 15px;
  }
}

/*!sc*/
.hYNhoE .container ul li a svg {
  margin-bottom: 20px;
  height: 64px;
}

/*!sc*/
@media (max-width:1024px) {
  .hYNhoE .container ul li a svg {
    height: 30px;
  }
}

/*!sc*/
.hYNhoE .container ul li a h4 {
  text-align: center;
  font-size: 0.7em;
  font-weight: 400;
  color: var(--brand_black);
  text-transform: uppercase;
  margin-bottom: 20px;
}

/*!sc*/
@media (max-width:1024px) {
  .hYNhoE .container ul li a h4 {
    margin-bottom: 10px;
    height: 36px;
    font-size: 0.75em;
  }
}

/*!sc*/
.hYNhoE .container ul li a p {
  color: var(--text_grey);
  font-size: 0.55em;
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
  font-weight: 300;
}

/*!sc*/
@media (max-width:1024px) {
  .hYNhoE .container ul li a p {
    font-size: 0.8em;
    display: none;
  }
}

/*!sc*/
.hYNhoE .container ul li a span {
  display: inline-block;
  position: absolute;
  bottom: 20px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
  color: var(--brand_black);
  font-size: 0.6em;
  font-weight: 400;
  padding: 0 10px;
  padding-bottom: 2px;
}

/*!sc*/
@media (max-width:1024px) {
  .hYNhoE .container ul li a span {
    display: none;
  }
}

/*!sc*/
.hYNhoE .container ul li a span:after {
  display: block;
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px;
  height: 1px;
  background-color: #dcdcdc;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
data-styled.g7[id="Collections__CollectionsSection-sc-10sxv7l-0"] {
  content: "hYNhoE,"
}

/*!sc*/
.hliIzh {
  width: 100%;
  display: block;
  height: 100vh;
  min-height: 620px;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  background-color: var(--brand_black);

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: white;
    color: white;
  }

  .swiper-button-next,
  .swiper-button-prev {
    color: white;
    top: unset;
    bottom: calc(50vh - 10px);

    &::after {
      font-size: 30px !important;
    }
  }
}

/*!sc*/
.hliIzh .glide_hero .glide__track {
  position: relative;
  cursor: default;
}

/*!sc*/
.hliIzh .glide_hero .glide__track .loading_slide {
  position: absolute;
  left: 15%;
  right: 15%;
  bottom: 70px;
  height: 3px;
  z-index: 10;
  background-color: rgba(165, 165, 165, 1);
  overflow: hidden;
}

/*!sc*/
@media (max-width:1024px) {
  .hliIzh .glide_hero .glide__track .loading_slide {
    bottom: 1px;
    left: 0;
    right: 0;
  }
}

/*!sc*/
.hliIzh .glide_hero .glide__track .loading_slide.play:after {
  -webkit-animation: runSlide 5s;
  animation: runSlide 5s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-fill-mode: forward;
  animation-fill-mode: forward;
}

/*!sc*/
.hliIzh .glide_hero .glide__track .loading_slide:after {
  content: ' ';
  background-color: white;
  display: block;
  width: 0;
  height: 3px;
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__arrow {
  top: auto;
  bottom: 30px;
  left: 60px;
  box-shadow: none;
  border: 1px solid white;
  border-radius: 0;
  padding: 12px 20px 12px 24px;
  font-size: 0.5em;
  -webkit-letter-spacing: 2px;
  -moz-letter-spacing: 2px;
  -ms-letter-spacing: 2px;
  letter-spacing: 2px;
  min-width: 130px;
  text-align: right;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
@media (max-width:1024px) {
  .hliIzh .glide_hero .glide__track .glide__arrow {
    left: 15px;
    min-width: 110px;
    bottom: 0px;
  }
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__arrow:hover {
  background-color: white;
  color: var(--brand_black);
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__arrow:hover svg {
  fill: var(--brand_black);
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__arrow svg {
  width: 20px;
  position: absolute;
  display: block;
  left: 15px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  fill: white;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__arrow--right {
  left: auto;
  right: 60px;
  text-align: left;
}

/*!sc*/
@media (max-width:768px) {
  .hliIzh .glide_hero .glide__track .glide__arrow--right {
    right: 16px;
  }
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__arrow--right svg {
  right: 15px;
  left: auto;
}

.hliIzh .swiper-slide {
  height: 100vh;
  position: relative;
  width: 100%;
  overflow: hidden;
  display: grid;
  place-items: center;
  -webkit-backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;

  img {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    object-fit: cover;
    height: 100%;
    min-width: 100%;
    z-index: 0;
  }

  .content {
    z-index: 2;
    text-align: center;

    h1 {
      font-size: 1.7em;
      font-weight: 400;
      color: white;
      font-family: var(--font_regular);
      margin-bottom: 30px;
      -webkit-letter-spacing: 1.5px;
      -moz-letter-spacing: 1.5px;
      -ms-letter-spacing: 1.5px;
      letter-spacing: 1.5px;

    }

    a {
      -webkit-text-decoration: none;
      text-decoration: none;
      color: white;
      -webkit-letter-spacing: 1.5px;
      -moz-letter-spacing: 1.5px;
      -ms-letter-spacing: 1.5px;
      letter-spacing: 1.5px;
      font-weight: 300;
      text-transform: uppercase;
      font-size: 0.6em;
      padding: 12px 30px;
      border: 1px solid transparent;
      font-family: var(--font_light);
      border: 1px solid white;
      -webkit-transition: var(--transition);
      transition: var(--transition);

      &:hover {
        background-color: white;
        color: var(--brand_black);
        -webkit-transition: var(--transition);
        transition: var(--transition);
      }
    }
  }

}

@media (max-width:768px) {
  .hliIzh .swiper-slide {

    img {
      width: 100vw;
      height: 50vh;
    }

  }
}

@media (max-width:1024px) {
  .hliIzh .swiper-slide {
    .content {
      padding: 0 15px;

      h1 {
        font-size: 1.3em;
        margin-bottom: 40px;
      }
    }
  }
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__slide {
  height: 100vh;
  position: relative;
  width: 100%;
  overflow: hidden;
  display: grid;
  place-items: center;
  -webkit-backface-visibility: hidden;
  -webkit-transform-style: preserve-3d;
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__slide:before {
  content: ' ';
  display: block;
  background-color: black;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.3;
  z-index: 1;
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__slide img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  object-fit: cover;
  height: 100%;
  min-width: 100%;
  z-index: 0;
}

/*!sc*/
@media (max-width:768px) {
  .hliIzh .glide_hero .glide__track .glide__slide img {
    width: 100vw;
    height: 50vh;
  }
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__slide .content {
  z-index: 2;
  text-align: center;
}

/*!sc*/
@media (max-width:1024px) {
  .hliIzh .glide_hero .glide__track .glide__slide .content {
    padding: 0 15px;
  }
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__slide .content h1 {
  font-size: 1.7em;
  font-weight: 400;
  color: white;
  font-family: var(--font_regular);
  margin-bottom: 30px;
  -webkit-letter-spacing: 1.5px;
  -moz-letter-spacing: 1.5px;
  -ms-letter-spacing: 1.5px;
  letter-spacing: 1.5px;
}

/*!sc*/
@media (max-width:1024px) {
  .hliIzh .glide_hero .glide__track .glide__slide .content h1 {
    font-size: 1.3em;
    margin-bottom: 40px;
  }
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__slide .content a {
  -webkit-text-decoration: none;
  text-decoration: none;
  color: white;
  -webkit-letter-spacing: 1.5px;
  -moz-letter-spacing: 1.5px;
  -ms-letter-spacing: 1.5px;
  letter-spacing: 1.5px;
  font-weight: 300;
  text-transform: uppercase;
  font-size: 0.6em;
  padding: 12px 30px;
  border: 1px solid transparent;
  font-family: var(--font_light);
  border: 1px solid white;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.hliIzh .glide_hero .glide__track .glide__slide .content a:hover {
  background-color: white;
  color: var(--brand_black);
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
data-styled.g8[id="Hero__HeroWrap-sc-7askzs-0"] {
  content: "hliIzh,"
}

/*!sc*/
.tMtBc {
  background-color: #f7f5f4;
  padding: 80px 0;
  -webkit-transition: var(--transition);
  transition: var(--transition);
  overflow: hidden;
}

/*!sc*/
@media (max-width:768px) {
  .tMtBc {
    padding: 60px 0;
  }
}

/*!sc*/
.tMtBc .container_full {
  max-width: 100%;
}

/*!sc*/
@media (max-width:1024px) {
  .tMtBc .container_full {
    padding: 0 30px;
  }
}

/*!sc*/
@media (max-width:768px) {
  .tMtBc .container_full {
    padding: 0 15px;
  }
}

/*!sc*/
.tMtBc .container_full .container_wide h2 {
  text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
  .tMtBc .container_full .container_wide h2 {
    text-align: center;
  }
}

/*!sc*/
.tMtBc .container_full .container_wide p {
  margin-bottom: 28px;
  text-align: left;
  max-width: 780px;
}

/*!sc*/
@media (max-width:1024px) {
  .tMtBc .container_full .container_wide p {
    text-align: center;
    max-width: 100%;
    margin-bottom: 40px;
  }
}

/*!sc*/
.tMtBc .container_full .container_wide p a {
  -webkit-text-decoration: none;
  text-decoration: none;
  font-size: 1em;
  color: var(--brand_black);
}

/*!sc*/
.tMtBc .container_full .container_wide p a:hover {
  -webkit-text-decoration: underline;
  text-decoration: underline;
}

/*!sc*/
.tMtBc .container_full .container_wide h3 {
  text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
  .tMtBc .container_full .container_wide h3 {
    text-align: center;
  }
}

/*!sc*/
.tMtBc .container_full .projects_list {
  padding: 60px 0;
  position: relative;
  overflow: hidden;
}

/*!sc*/
@media (max-width:768px) {
  .tMtBc .container_full .projects_list {
    grid-template-columns: repeat(2, 1fr);
    padding: 0;
  }
}

/*!sc*/
@media (max-width:480px) {
  .tMtBc .container_full .projects_list {
    grid-template-columns: 1fr;
    display: block;
  }
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__track {
  position: relative;
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__track .controls button {
  position: absolute;
  background: #fff;
  top: 33%;
  left: 65px;
  border-radius: 50%;
  outline: none;
  width: 34px;
  height: 34px;
  padding-top: 5px;
  z-index: 100000;
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__track .controls button svg {
  display: block;
  width: 22px;
  height: 26px;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/*!sc*/
@media (max-width:1024px) {
  .tMtBc .container_full .projects_list .glide__track .controls button {
    left: 15px;
    top: 35%;
    padding-top: 5px;
  }
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__track .controls button.slide_right {
  left: auto;
  right: 65px;
}

/*!sc*/
@media (max-width:1024px) {
  .tMtBc .container_full .projects_list .glide__track .controls button.slide_right {
    right: 15px;
  }
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__slides {
  list-style-type: none;
  padding: 0;
  margin: 0;
  overflow: hidden;
  position: relative;
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__slides .glide__slide {
  position: relative;
  opacity: 0.6;
  list-style-type: none;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__slides .glide__slide.is_visible,
.tMtBc .container_full .projects_list .glide__slides .glide__slide.glide__slide--active {
  opacity: 1;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__slides .glide__slide a {
  -webkit-text-decoration: none;
  text-decoration: none;
  display: block;
  color: var(--brand_black);
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__slides .glide__slide a .image_wrap {
  position: relative;
  overflow: hidden;
  border-radius: 6px;
  margin-bottom: 20px;
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__slides .glide__slide a .image_wrap:hover img {
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__slides .glide__slide a .image_wrap img {
  display: block;
  width: 100%;
  max-height: 200px;
  min-height: 150px;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
@media (max-width:1550px) {
  .tMtBc .container_full .projects_list .glide__slides .glide__slide a .image_wrap img {
    height: 190px;
  }
}

/*!sc*/
@media (max-width:1400px) {
  .tMtBc .container_full .projects_list .glide__slides .glide__slide a .image_wrap img {
    height: 180px;
  }
}

/*!sc*/
@media (max-width:768px) {
  .tMtBc .container_full .projects_list .glide__slides .glide__slide a .image_wrap img {
    height: 160px;
  }
}

/*!sc*/
@media (max-width:480px) {
  .tMtBc .container_full .projects_list .glide__slides .glide__slide a .image_wrap img {
    height: 140px;
  }
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__slides .glide__slide a h5 {
  font-size: 0.5em;
  font-weight: 300;
  text-transform: uppercase;
  margin: 0;
  margin-bottom: 5px;
  -webkit-letter-spacing: 0.5px;
  -moz-letter-spacing: 0.5px;
  -ms-letter-spacing: 0.5px;
  letter-spacing: 0.5px;
}

/*!sc*/
@media (max-width:768px) {
  .tMtBc .container_full .projects_list .glide__slides .glide__slide a h5 {
    font-size: 0.6em;
  }
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__slides .glide__slide a h5 span {
  margin: 0 10px;
}

/*!sc*/
.tMtBc .container_full .projects_list .glide__slides .glide__slide a h4 {
  font-size: 0.6em;
  font-weight: 400;
  color: var(--brand_black);
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
}

/*!sc*/
@media (max-width:768px) {
  .tMtBc .container_full .projects_list .glide__slides .glide__slide a h4 {
    font-size: 0.8em;
  }
}

/*!sc*/
.tMtBc .container_full .link_wrapper {
  margin-top: 0;
}

/*!sc*/
@media (max-width:1024px) {
  .tMtBc .container_full .link_wrapper {
    margin-top: 40px;
  }
}

/*!sc*/
data-styled.g9[id="Projects__RecentProjects-sc-18echsy-0"] {
  content: "tMtBc,"
}

/*!sc*/
.ccBpZc {
  padding: 80px 0;
  position: relative;
}

/*!sc*/
@media (max-width:1024px) {
  .ccBpZc {
    padding: 60px 0;
  }
}

/*!sc*/
.ccBpZc .container {
  max-width: 940px;
}

/*!sc*/
.ccBpZc .container h2 {
  margin-bottom: 60px;
}

/*!sc*/
@media (max-width:768px) {
  .ccBpZc .container h2 {
    margin-bottom: 40px;
  }
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list {
  border: none;
  width: 100%;
}

/*!sc*/
@media (max-width:1024px) {
  .ccBpZc .container .react-tabs .react-tabs__tab-list {
    overflow-x: scroll;
    overflow-y: hidden;
    margin-bottom: 0;
  }
}

/*!sc*/
@media (max-width:1024px) {
  .ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    place-items: center;
    width: 100%;
  }
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab {
  border: none;
  margin-right: 10px;
  padding-left: 0;
  vertical-align: top;
  -webkit-align-self: start;
  -ms-flex-item-align: start;
  align-self: start;
  text-align: center;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab:hover {
  -webkit-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab:hover h3 {
  color: black;
  -webkit-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
}

/*!sc*/
@media (max-width:768px) {
  .ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab {
    margin-right: 0;
  }
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab h3 {
  font-size: 0.6em;
  line-height: 16px;
  -webkit-letter-spacing: 0.05em;
  -moz-letter-spacing: 0.05em;
  -ms-letter-spacing: 0.05em;
  letter-spacing: 0.05em;
  font-weight: 400;
  margin: 0 auto;
  color: #818181;
  max-width: 110px;
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab .svg_wrapper {
  width: 83px;
  height: 83px;
  border-radius: 50%;
  margin: 0 auto;
  margin-bottom: 16px;
  -webkit-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
  position: relative;
  z-index: 10000;
  background-color: #f8f8f8;
}

/*!sc*/
@media (max-width:1024px) {
  .ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab .svg_wrapper {
    width: 60px;
    height: 60px;
  }
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab .svg_wrapper svg {
  z-index: 10000;
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

/*!sc*/
@media (max-width:1024px) {
  .ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab .svg_wrapper svg {
    -webkit-transform: translate(-50%, -50%) scale(0.7);
    -ms-transform: translate(-50%, -50%) scale(0.7);
    transform: translate(-50%, -50%) scale(0.7);
  }
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab .svg_wrapper:before {
  content: '';
  background: #f8f8f8;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  border: 2px solid #ffaa30;
  border-radius: 50%;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  opacity: 0;
  -webkit-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab .svg_wrapper:hover:before {
  border: 2px solid #65b1e7;
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
  opacity: 1;
  -webkit-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab--selected {
  color: #000000;
  background: none;
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab--selected h3 {
  color: var(--brand_black);
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab--selected .svg_wrapper {
  position: relative;
  background-color: #f8f8f8;
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab--selected .svg_wrapper:before {
  content: '';
  background: #f8f8f8;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  border: 2px solid #ffaa30;
  border-radius: 50%;
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
  opacity: 1;
  -webkit-transition: 0.4s ease-in-out;
  transition: 0.4s ease-in-out;
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-list .tabs_wrap .react-tabs__tab--selected .svg_wrapper:hover:before {
  border: 2px solid #ffaa30;
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-panel {
  padding-top: 45px;
}

/*!sc*/
@media (max-width:1024px) {
  .ccBpZc .container .react-tabs .react-tabs__tab-panel {
    padding-top: 25px;
  }
}

/*!sc*/
@media (max-width:1024px) {
  .ccBpZc .container .react-tabs .react-tabs__tab-panel .content {
    margin-bottom: 0;
  }
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-panel .content h4 {
  font-size: 1.6em;
  font-weight: 300;
  line-height: 38px;
  -webkit-letter-spacing: 1px;
  -moz-letter-spacing: 1px;
  -ms-letter-spacing: 1px;
  letter-spacing: 1px;
  color: #595959;
  text-align: left;
  text-transform: none;
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-panel .content h4 strong {
  color: #333333;
  font-weight: 600;
}

/*!sc*/
@media (max-width:768px) {
  .ccBpZc .container .react-tabs .react-tabs__tab-panel .content h4 {
    text-align: center;
  }
}

/*!sc*/
.ccBpZc .container .react-tabs .react-tabs__tab-panel .content p {
  margin-top: 25px;
  text-align: left;
}

/*!sc*/
@media (max-width:768px) {
  .ccBpZc .container .react-tabs .react-tabs__tab-panel .content p {
    text-align: center;
    word-wrap: break-word;
  }
}

/*!sc*/
data-styled.g10[id="TailoredForIndustry__TailoredTabs-sc-1g08m1a-0"] {
  content: "ccBpZc,"
}

/*!sc*/
.eHMvFR {
  display: block;
  background: #f7f5f4;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
@media (max-width:1024px) {
  .eHMvFR .container_small .heading {
    text-align: center;
  }
}

/*!sc*/
.eHMvFR .container_small .heading h2 {
  text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
  .eHMvFR .container_small .heading h2 {
    text-align: center;
  }
}

/*!sc*/
.eHMvFR .container_small .heading h4 {
  text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
  .eHMvFR .container_small .heading h4 {
    text-align: center;
  }
}

/*!sc*/
.eHMvFR .container_small .content {
  margin-bottom: 60px;
  width: 80%;
  text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
  .eHMvFR .container_small .content {
    text-align: center;
    width: 100%;
    margin-bottom: 30px;
  }
}

/*!sc*/
.eHMvFR .container_small .why_grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 25px;
}

/*!sc*/
@media (max-width:1024px) {
  .eHMvFR .container_small .why_grid {
    grid-template-columns: 1fr;
    gap: 0;
  }
}

/*!sc*/
.eHMvFR .container_small .why_grid .video {
  position: relative;
}

/*!sc*/
.eHMvFR .container_small .why_grid .video svg {
  position: absolute;
  width: 30px;
  height: 30px;
  fill: white;
  color: white;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 4;
  cursor: pointer;
  pointer-events: none;
}

/*!sc*/
.eHMvFR .container_small .why_grid .video video {
  display: block;
  width: 100%;
  outline: none;
}

/*!sc*/
.eHMvFR .container_small .why_grid .gallery {
  padding-top: 56%;
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
  border-radius: 4px;
}

/*!sc*/
@media (max-width:1024px) {
  .eHMvFR .container_small .why_grid .gallery {
    display: none;
  }
}

/*!sc*/
.eHMvFR .container_small .why_grid .gallery img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  min-height: 100%;
  -webkit-transition: var(--transition);
  transition: var(--transition);
}

/*!sc*/
@media (max-width:1024px) {
  .eHMvFR .link_wrapper {
    margin-top: 40px;
  }
}

/*!sc*/
data-styled.g11[id="Why__WhySection-q1jlkv-0"] {
  content: "eHMvFR,"
}

/*!sc*/
</style>